import * as Namespaces from './namespaces'

const locales = {
	[Namespaces.GRID_STATE]: {
		el: {
			'Custom view': 'Προσαρμοσμένη όψη',
			'Cancel': 'Ακύρωση',
			'Create view': 'Νέα Όψη',
			'Save current view': 'Αποθήκευση όψης',
			'Custom view label': 'Ετικέτα όψης',
			'New custom view': 'Νέα προσαρμοσμένη όψη'
		},
		en: {}
	},
	[Namespaces.EXHIBITION]: {
		el: {
			'Image upload, paste and drag-and-drop are disabled. Use Insert/edit image and enter an image URL.': 'Η μεταφόρτωση, η επικόλληση και η μεταφορά εικόνων έχουν απενεργοποιηθεί. Επιλέξτε «Εισαγωγή/επεξεργασία εικόνας» και εισαγάγετε τη διεύθυνση URL της εικόνας.',
			"You haven't uploaded yet your advertisement logo.": 'Δεν έχετε φορτώσει το διαφημιστικό σας logo.',
			'Exhibitor Logo Template Image': 'Πρότυπη Εικόνα Λογοτύπου Εκθέτη',
			'exhibitor_template_logo_image': 'Μεταφορτώστε <strong>ένα μόνο</strong> αρχείο εικόνας, το οποίο θα χρησιμοποιηθεί ως πρότυπο για την τελική εικόνα του εκθέτη. Γίνονται δεκτά μόνο αρχεία <strong>.png</strong> και η εικόνα πρέπει να έχει ακριβώς διαστάσεις <strong>4500 x 5625 pixels</strong>. <br/> Όταν ένας εκθέτης ανεβάζει λογότυπο, το σύστημα δημιουργεί αυτόματα μια νέα εικόνα από αυτό το πρότυπο, τοποθετώντας το περίπτερο και το όνομα του εκθέτη σε προκαθορισμένες θέσεις μέσα στην τελική εικόνα.<br/>',
			'File uploaded successfully!': 'Το αρχείο μεταφορτώθηκε επιτυχώς!',
			'Failed to upload file!': 'Η μεταφόρτωση του αρχείου απέτυχε!',
			'File deleted successfully!': 'Το αρχείο διαγράφηκε επιτυχώς!',
			'Failed to delete file!': 'Η διαγραφή του αρχείου απέτυχε!',
			'The image must be 4500 x 5625 pixels!': 'Η εικόνα πρέπει να είναι 4500 χ 5625 pixels!',
			'The image must be 2250 x 1010 pixels!': 'Η εικόνα πρέπει να είναι 2250 x 1010 pixels!',
			'Email may be incorrect.': 'Το email ενδέχεται να μην είναι σωστό.',
			'Email validation failed!': 'Αποτυχία επαλήθευσης email!',
			'This exhibition is part of a coorganization and not the main coorganization exhibition. As such, SMS Sender Name Settings are note applied in Registration Form. For Registration Form visit main coorganization exhibition settings.': 'Αυτή η έκθεση αποτελεί μέλος συνδιοργάνωσης, αλλά δεν έχει καθοριστεί ως η κύρια έκθεση της συνδιοργάνωσης. Η παραμετροποίηση του Ονόματος Αποστολέα SMS δεν εφαρμόζονται στη Φόρμα Registration. Για να παραμετροποιήσετε την Φόρμα Registration, μεταβείτε στις ρυθμίσεις της κύριας έκθεσης της συνδιοργάνωσης.',
			'This exhibition is part of a coorganization and not the main coorganization exhibition. As such, Email Sender Name Settings are note applied in Registration Form. For Registration Form visit main coorganization exhibition settings.': 'Αυτή η έκθεση αποτελεί μέλος συνδιοργάνωσης, αλλά δεν έχει καθοριστεί ως η κύρια έκθεση της συνδιοργάνωσης. Η παραμετροποίηση του Ονόματος Αποστολέα Email δεν εφαρμόζονται στη Φόρμα Registration. Για να παραμετροποιήσετε την Φόρμα Registration, μεταβείτε στις ρυθμίσεις της κύριας έκθεσης της συνδιοργάνωσης.',
			'This exhibition is part of a coorganization and not the main coorganization exhibition. As such, Sender Email Settings are note applied in Registration Form. For Registration Form visit main coorganization exhibition settings.': 'Αυτή η έκθεση αποτελεί μέλος συνδιοργάνωσης, αλλά δεν έχει καθοριστεί ως η κύρια έκθεση της συνδιοργάνωσης. Η παραμετροποίηση του Email Αποστολέα δεν εφαρμόζονται στη Φόρμα Registration. Για να παραμετροποιήσετε την Φόρμα Registration, μεταβείτε στις ρυθμίσεις της κύριας έκθεσης της συνδιοργάνωσης.',
			'Registration settings are disabled. This exhibition is part of a coorganization. Registration settings are inherited from main exhibition.': 'Οι ρυθμίσεις registration έχουν απενεργοποιηθεί. Αυτή η έκθεση αποτελεί μέλος συνδιοργάνωσης. Οι ρυθμίσεις του registration που ισχύουν εφαρμόζονται μέσω της κύριας έκθεσης της συνδιοργάνωσης.',
			'This exhibition is part of a coorganization and not the main coorganization exhibition. As such, Field Settings are only used for Pre-Registation Form. To modify Registration Form, visit the main coorganization exhibition settings.': 'Αυτή η έκθεση αποτελεί μέλος συνδιοργάνωσης, αλλά δεν έχει καθοριστεί ως η κύρια έκθεση της συνδιοργάνωσης. Η παραμετροποίηση των πεδίων αφορά μόνο την Φόρμα Pre-Registration για την έκθεση. Για να παραμετροποιήσετε την Φόρμα Registration, μεταβείτε στις ρυθμίσεις της κύριας έκθεσης της συνδιοργάνωσης.',
			'Member of Coorganization': 'Μέλος Συνδιοργάνωσης',
			'Main Coorganization Exhibition': 'Κύρια Έκθεση Συνδιοργάνωσης',
			'Warning': 'Προειδοποίηση',
			'Exhibition Settings': 'Ρυθμίσεις Έκθεσης',
			'Scan Visitors': 'Σάρωση επισκεπτών',
			'My Visitors': 'Οι Επισκέπτες Μου',
			'Allow Exhibitor To Scan Visitors': 'Δυνατότητα Σάρωσης Επισκεπτών Από Εκθέτη',
			'If you enable this, selected exhibitors will be able to scan visitors from their kiosk.': 'Εάν το ενεργοποιήσετε, τότε οι εκθέτες θα μπορούν να σαρώνουν επισκέπτες από το περίπτερό τους.',
			'free_advertisement_upload_info': '<strong>Διαφημιστική Καταχώρηση Καταλόγου.</strong><br/><br/>Έχετε τη δυνατότητα να τοποθετήσετε δωρεάν μία ολοσέλιδη διαφημιστική καταχώρηση με τα στοιχεία της εταιρείας σας.<br/><br/>Μπορείτε να μεταφορτώσετε <strong>ένα</strong> αρχείο για τη Διαφημιστική Καταχώρηση.<br/> Επιτρέπονται μόνο <strong>.jpg</strong>, <strong>.png</strong> και <strong>.pdf</strong> αρχεία έως <strong>20Mb</strong>. Η διάσταση της καταχώρησης πρέπει να είναι <strong>21 x 29,7(A4)</strong><br/><br/>Η Διαφημιστική Καταχώρηση παραμένει επεξεργάσιμη έως την ημερομηνία κλειδώματος του καταλόγου.<br/><br/><strong>Προσοχή! Οι διαφημιστικές καταχωρήσεις θα ακολουθούν τον κατάλογο της έκθεσης και θα εμφανίζονται με τυχαία σειρά.  Για τον λόγο αυτό, είναι απαραίτητο να αναφέρονται πλήρως τα στοιχεία της εταιρείας σας.</strong>',
			'Free Catalogue Advertisement': 'Διαφημιστική Καταχώρηση Καταλόγου',
			'{{count}} emails where created and are queued for sending. For large number of emails, this process may take several hours!': '{{count}} emails δημιουργήθηκαν και βρίσκονται στη σειρά για αποστολή. Για μεγάλο αριθμό emails, αυτή η διαδικασία μπορεί να πάρει αρκετές ώρες!',
			'Message Error (3)': 'Η αποστολή δεν πραγματοποιήθηκε. Παρακαλώ επιβεβαιώστε ότι ο τύπος αποστολής 3 (Πρόσκληση προς συνεργάτη) έχει ενεργοποιηθεί και δεν είναι κενός στις ρυθμίσεις email/sms της έκθεσης.',
			'Message Error (1)': 'Η αποστολή δεν πραγματοποιήθηκε. Παρακαλώ επιβεβαιώστε ότι ο τύπος αποστολής 1 (Πρόσκληση προς εκθέτη (username/password)) έχει ενεργοποιηθεί και δεν είναι κενός στις ρυθμίσεις email/sms της έκθεσης.',
			'Message Error (4, 8)': 'Η αποστολή δεν πραγματοποιήθηκε. Παρακαλώ επιβεβαιώστε ότι οι τύποι αποστολής 4 (Ολοκλήρωση προεγγραφής (Email)) και 8 (Ολοκλήρωση προεγγραφής (SMS)) έχουν ενεργοποιηθεί και δεν είναι κενοί στις ρυθμίσεις email/sms της έκθεσης.',
			'Message Error (5)': 'Η αποστολή δεν πραγματοποιήθηκε. Παρακαλώ επιβεβαιώστε ότι ο τύπος αποστολής 5 (Απόρριψη προεγγραφής) έχει ενεργοποιηθεί και δεν είναι κενός στις ρυθμίσεις email/sms της έκθεσης.',
			'Message Error (9)': 'Η αποστολή δεν πραγματοποιήθηκε. Παρακαλώ επιβεβαιώστε ότι ο τύπος αποστολής 9 (Πρόσκληση προς επισκέπτη (από εκθέτη)) έχει ενεργοποιηθεί και δεν είναι κενός στις ρυθμίσεις email/sms της έκθεσης. Εάν δεν είσαστε οργανωτής, παρακαλώ επικοινωνήστε με τους διαχειριστές της εφαρμογής.',
			'Message Error (10, 11)': "Η αποστολή δεν πραγματοποιήθηκε. Παρακαλώ επιβεβαιώστε ότι ο τύπος αποστολής 11 (Πρόσκληση με import (από οργανωτή)) ή/και ο τύπος 10 (Πρόσκληση προς επισκέπτη (SMS)) έχουν ενεργοποιηθεί και δεν είναι κενοί στις ρυθμίσεις email/sms της έκθεσης.",
			'message_type_instructions_1': 'Αποστέλλεται από τους οργανωτές από τον πίνακα των εκθετών της έκθεσης (αποστολή σε νέους, αποστολή σε όλους, αποστολή σε επιλεγμένους εκθέτες).',
			'message_type_instructions_3': 'Αποστέλλεται όταν ο εκθέτης ή ο οργανωτής, επιλέξει να στείλει προσκλήσεις σε συνεργάτες του εκθέτη. (Στέλνεται επίσης και από τους αντίστοιχους πίνακες σε service providers, κατασκευαστές, προσωπικό έκθεσης και οργανωτές.)',
			'message_type_instructions_4': 'Αποστέλλεται όταν ο οργανωτής εγκρίνει την αίτηση προεγγραφής ενός επισκέπτη.',
			'message_type_instructions_5': 'Αποστέλλεται όταν ο οργανωτής απορρίψει τον επισκέπτη που έκανε την προεγγραφή του, εφόσον έχει ενεργοποιηθεί η διαδικασία έγκρισης επισκεπτών από τις ρυθμίσεις της έκθεσης. ',
			'message_type_instructions_6': 'Αποστέλλεται αυτόματα, εφόσον έχει ενεργοποιηθεί η διαδικασία ειδοποίησης προς τον εκθέτη. Η αποστολή πραγματοποιείται στις 9 το πρωί, συγκεκριμένη μέρα πριν την εκκίνηση της έκθεσης, η οποία έχει δηλωθεί στις ρυθμίσεις της έκθεσης.',
			'message_type_instructions_7': 'Αποστέλλεται όταν ο επισκέπτης πατήσει αποθήκευση στην προεγγραφή, εφόσον έχει ενεργοποιηθεί η διαδικασία έγκρισης επισκεπτών από τις ρυθμίσεις της έκθεσης.',
			'message_type_instructions_8': 'Αποστέλλεται όταν ο οργανωτής εγκρίνει την αίτηση προεγγραφής ενός επισκέπτη.',
			'message_type_instructions_9': 'Αποστέλλεται στις παρακάτω περιπτώσεις, ανεξαρτήτως του αν είναι ενεργοποιημένη η διαδικασία προεγγραφής.<ul><li>Όταν ένας εκθέτης στέλνει πρόσκληση στους επισκέπτες του από τον πίνακα επισκεπτών του.</li><li>Ο οργανωτής μπει στην καρτέλα ενός εκθέτη και πατήσει αποστολή από τον πίνακα των επισκεπτών του εκθέτη.</li></ul> ',
			'message_type_instructions_10': 'Αποστέλλεται στις παρακάτω περιπτώσεις.<ul><li>Η προεγγραφή είναι απενεργοποιημένη και ο οργανωτής στέλνει πρόσκληση στους επισκέπτες από τον πίνακα των επισκεπτών (σε όλους, σε νέους, σε επιλεγμένους επισκέπτες).</li><li>Η προεγγραφή είναι ενεργοποιημένη και ο οργανωτής στέλνει πρόσκληση στους επισκέπτες από τον πίνακα των επισκεπτών της έκθεσης, ανεξαρτήτως του αν είναι ενεργή η διαδικασία έγκρισης (σε όλους, σε νέους, σε επιλεγμένους επισκέπτες).</li><li>Ο οργανωτής κάνει import επισκεπτών από excel, ανεξαρτήτως του αν είναι ενεργή η διαδικασία προεγγραφής.</li></ul>',
			'message_type_instructions_11': 'Αποστέλλεται στις παρακάτω περιπτώσεις.<ul><li>Η προεγγραφή είναι απενεργοποιημένη και ο οργανωτής κάνει αποστολή στους επισκέπτες, από τον πίνακα επισκεπτών της έκθεσης (αποστολή σε όλους, αποστολή σε νέους, αποστολή σε επιλεγμένους).</li><li>Η προεγγραφή είναι ενεργοποιημένη και ο οργανωτής κάνει αποστολή στους επισκέπτες, από τον πίνακα επισκεπτών της έκθεσης, ανεξαρτήτως του αν είναι ενεργή η διαδικασία έγκρισης (αποστολή σε όλους, αποστολή σε νέους, αποστολή σε επιλεγμένους).</li><li>Ο οργανωτής εισάγει επισκέπτες μέσω excel (ανεξαρτήτως του αν είναι ενεργοποιημένη η διαδικασία προεγγραφής).</li></ul>',
			'message_type_instructions_12': 'Αποστέλλεται στο email info@rota.gr, όταν ένας επισκέπτης που κάνει προεγγραφή δηλώνει χώρα εκτός Ελλάδας. Πρέπει να έχει ενεργοποιηθεί η διαδικασία Preregistration από τις ρυθμίσεις της έκθεσης.',
			'message_type_instructions_13': 'Αποστέλλεται κατά το registration στο εκθεσιακό, εφόσον είναι ενεργοποιημένη η ενημέρωση μέσω email.',
			'message_type_instructions_14': 'Αποστέλλεται κατά το registration στο εκθεσιακό, εφόσον είναι ενεργοποιημένη η ενημέρωση μέσω SMS.',
			'Message template updated successfully!': 'Το κείμενο ενημερώθηκε επιτυχώς!',
			'Catalogue locked': 'Η επεξεργασία του καταλόγου σας έχει κλειδώσει!',
			'Read More On Google Docs': 'Διαβάστε περισσότερες πληροφορίες στη Google',
			'Valid Script Example for GOOGLE TAG': 'Έγκυρο Παράδειγμα Script για Google Tag',
			'Google Tag Code': 'Κωδικός Google Tag',
			'To enable gtag script for preregistration insert a valid gtag code here. If empty, gtag script will not execute.': 'Για να ενεργοποιήσετε το gtag script για την προεγγραφή, εισάγεται έναν έγκυρο gtag κωδικό εδώ. Εάν, παραμείνει κενό δεν εκτελείται το google script.',
			'Fetching user teams failed': 'Αποτυχία λήψης ομάδων χρηστών',
			'Set a color for exhibitor buttons.': 'Επιλογή χρώματος για τις ενέργειες εκθετών.',
			'Export': 'Εξαγωγή',
			'Select export filters and press EXPORT.': 'Επιλέξετε φίλτρα και πατήστε ΕΞΑΓΩΓΗ.',
			'Prereg. Date From': 'Ημερομηνία Προεγ. Από',
			'Prereg. Date To': 'Ημερομηνία Προεγ. Έως',
			'Date From': 'Ημερομηνία Από',
			'Date To': 'Ημερομηνία Έως',
			'EXPORT PREREGISTRATION REPORT': 'ΕΞΑΓΩΓΗ ΑΝΑΦΟΡΑΣ ΠΡΟΕΓΓΡΑΦΗΣ',
			'Export preregistration data by applying with specific filters.': 'Εξαγωγή δεδομένων προεγγραφής με εφαρμογή συγκεκριμένων φίλτρων.',
			'EXPORT VISITOR REPORT': 'ΕΞΑΓΩΓΗ ΑΝΑΦΟΡΑΣ ΕΠΙΣΚΕΠΤΩΝ',
			'Export visitor data by applying with specific filters.': 'Εξαγωγή δεδομένων επισκεπτών με εφαρμογή συγκεκριμένων φίλτρων.',
			'Export all visitor data. This excel can be used to import visitors in EnterSoft.': 'Εξαγωγή δεδομένων όλων των επισκεπτών που προσήλθαν. Αυτό το excel μπορεί να χρησιμοποιηθεί για εισαγωγή των επισκεπτών στο EnterSoft.',
			'Exhibition settings copied successfully!': 'Οι ρυθμίσεις της έκθεσης έχουν αντιγραφεί επιτυχώς!',
			'NO': 'ΟΧΙ',
			'YES': 'ΝΑΙ',
			'Instructions': 'Οδηγίες',
			'This action cannot be revoked. Press YES if you want to proceed.': 'Αυτή η ενέργεια δεν μπορεί να ανακληθεί. Πατήστε ΝΑΙ εάν θέλετε να προχωρήσετε με την αντιγραφή των ρυθμίσεων.',
			'Confirm Settings Copy': 'Επιβεβαίωση Αντιγραφής Ρυθμίσεων',
			'Please select an exhibition!': 'Παρακαλώ επιλέξετε μία έκθεση!',
			'Copy Settings': 'Αντιγραφή Ρυθμίσεων',
			'Select exhibition': 'Επιλογή έκθεσης',
			'exhibition_copy_settings': 'Στην παρούσα σελίδα μπορείτε να επιλέξετε μία έκθεση και να <strong>αντιγράψετε</strong> τις ρυθμίσεις της <strong>στην έκθεση στην οποία βρίσκεστε</strong>. <br/> Θα πραγματοποιηθεί αντιγραφή των ρυθμίσεων: <ul><li>Ρυθμίσεις καταλόγου για τη γλώσσα, το κλείδωμα, το όριο χαρακτήρων, το όριο υποβολής και τις ημέρες υπενθύμισης.</li><li>Ρυθμίσεις μετόπης.</li><li>Ρυθμίσεις για τα brands.</li><li>Ρυθμίσεις preregistration για τις χώρες ισχύος, τη διαδικασία έγκρισης, τις ομάδες πεδίων και τα πεδία της φόρμας. <strong>Οι ημερομηνίες ισχύος του preregistration και η ρύθμιση ενεργοποίησής της δεν αντιγράφονται!</strong></li><li>Ρυθμίσεις του registration για τις μέρες που ανοίγει πριν και μετά την έκθεση, τα πεδία της φόρμας και την απενεργοποίηση της αποστολής μηνυμάτων.</li><li>Ρυθμίσεις αποστολέα Email.</li><li>Ρυθμίσεις κατηγοριών επισκεπτών.</li><li>Ρυθμίσεις QR.</li><li>Περιεχόμενο κειμένων SMS και Email. <strong>Κατά την αντιγραφή των κειμένων οι τύποι Email και SMS γίνονται ανενεργοί!</strong></li><li>Περιεχόμενο αρχικής σελίδας έκθεσης και μενού.</li><li>Κείμενο Badges.</li><li>Ρυθμίσεις εκτύπωσης χρώματος και μεγέθους για επισκέπτες, συνεργάτες, service providers, κατασκευαστές, προσωπικό έκθεσης, οργανωτές και το registration.</li><li>Κατηγορίες επισκεπτών και ειδικοί κανόνες εκτύπωσης.</li></ul><br/><strong>Προσοχή: Δεν μπορούν να αντιγραφούν ρυθμίσεις σε έκθεση που τρέχει! Αυτή η λειτουργικότητα δεν είναι διαθέσιμη κατά τη διάρκεια της έκθεσης, 20 μέρες πριν την αρχή της έκθεσης και για εκθέσεις για τις οποίες έχει ενεργοποιηθεί το preregistration!</strong><br/><br/><strong>Διαθέσιμες εκθέσεις για την αντιγραφή ρυθμίσεων είναι εκθέσεις που ξεκινάνε μετά τις 01/06/2024.</strong>',
			'Select an other exhibition, to copy its settings to current exhibition.': 'Επιλέξετε μια άλλη έκθεση, για να αντιγράψετε τις ρυθμίσεις της στην έκθεση στην οποία βρίσκεστε.',
			'Copy Exhibition Settings': 'Αντιγραφή Ρυθμίσεων Έκθεσης',
			'Message updated successfully!': 'Το μήνυμα ενημερώθηκε επιτυχώς!',
			'Customize information messages in pages available to exhibitors.': 'Παραμετροποίηση ενημερωτικών μηνυμάτων στις σελίδες, οι οποίες είναι διαθέσιμες στους εκθέτες.',
			'Select Message': 'Επιλογή Μηνύματος',
			'Customize Info Messages To Exhibitors': 'Παραμετροποίηση Ενημερωτικών Κειμένων Εκθετών',
			'In Greek Text': 'Στο Ελληνικό Κείμενο',
			'In English Text': 'Στο Αγγλικό Κείμενο',
			'On this page you can customize informative messages, that appear on pages available to exhibitors.': 'Στην παρούσα σελίδα μπορείτε να γράψετε το ενημερωτικό κείμενο που εμφανίζεται σε διάφορες σελίδες, οι οποίες είναι διαθέσιμες στους εκθέτες.',
			'You can copy and paste this variable in your text to display final date of catalogue submission.': 'Μπορείτε να αντιγράψετε και να πραγματοποιήσετε επικόλληση της παρακάτω μεταβλητής μέσα στο κείμενό σας, προκειμένου να εμφανίσετε την τελική ημερομηνία υποβολής καταλόγου.',
			'multiple_catalogue_exports': 'Στην παρούσα σελίδα μπορείτε εξάγετε τον κατάλογο μίας ή παραπάνω εκθέσεων σε <strong>word</strong>.',
			'Delete Logo': 'Διαγραφή Logo',
			'Advertisement logo deleted successfully!': 'Το διαφημιστικό logo έχει διαγραφεί επιτυχώς!',
			'Free advertisement deleted successfully!': 'Η διαφημιστική καταχώρηση έχει διαγραφεί επιτυχώς!',
			'Failed to delete advertisement logo!': 'Η διαγραφή του διαφημιστικού logo απέτυχε!',
			'Failed to delete free advertisement!': 'Η διαγραφή της διαφημιστικής καταχώρησης απέτυχε!',
			'General Reports': 'Γενικές Αναφορές',
			'entersoft-transfers': 'Στην παρούσα σελίδα μπορείτε να πραγματοποιήσετε ενημέρωση των δεδομένων των εκθέσεων από το EnterSoft.',
			'create-coorganization': 'Στην παρούσα σελίδα μπορείτε να δημιουργείστε νέα συνδιοργάνωση και να συνδέσετε εκθέσεις με αυτήν.',
			'reports_general_statistics': 'Στην παρούσα σελίδα μπορείτε να δείτε μία σύνοψη των <strong>στατιστικών πολλαπλών εκθέσεων</strong>.<br/> Επιλέξτε τουλάχιστον μία έκθεση για να δείτε τις αναφορές.',
			'Exhibition': 'Έκθεση',
			'Coorganization': 'Συνδιοργάνωση',
			'Visitors removed successfully!': 'Οι επισκέπτες διαγράφηκαν επιτυχώς!',
			'One or more selected visitors have already been scanned and cannot be deleted!': 'Ένας ή περισσότεροι από τους επιλεγμένους επισκέπτες, έχουν ήδη σκαναριστεί και δεν μπορούν να διαγραφούν!',
			'Image deleted successfully!': 'Η εικόνα διαγράφηκε επιτυχώς!',
			'Image uploaded successfully!': 'Η εικόνα μεταφορτώθηκε επιτυχώς!',
			'exhibition_images': 'Στην παρούσα σελίδα μπορείτε να <strong>μεταμορφώσετε</strong> εικόνες και να χρησιμοποιήσετε τους συνδέσμους τους στα κείμενα των emails.',
			'Image Upload': 'Μεταφόρτωση Εικόνας',
			'Image Url': 'Σύνδεσμος Εικόνας',
			'Images For Emails': 'Εικόνες Emails',
			'Download We Participate Kit/ Exhibition Logo': 'Λήψη Κιτ Συμμετέχουμε/ Logo Έκθεσης',
			'Advertisement logo uploaded successfully!': 'Το διαφημιστικό logo μεταφορτώθηκε επιτυχώς',
			'Failed to upload advertisement logo!': 'Η μεταφόρτωση του διαφημιστικού logo απέτυχε!',
			'exhibitor_kit_and_ad_logos': 'Eδώ μπορείτε να αναρτήσετε το logo της εταιρείας σας σε μορφή <strong>JPG</strong> ή <strong>PNG</strong> σε ανάλυση 2250 x 1010, για χρήση σε διαφημιστικά και στη <strong>λίστα εκθετών</strong>. <br/> Επιπλέον, μπορείτε να κατεβάσετε το <strong>Marketing Kit</strong>, χρήσιμο <strong>διαφημιστικό</strong> υλικό για την καλύτερη προώθηση της συμμετοχής σας στην έκθεση.',
			'exhibitor_scan_visitors': 'Εδώ μπορείτε να πραγματοποιήσετε σάρωση των επισκεπτών σας.',
			'exhibitor_scanned_visitors': 'Εδώ μπορείτε να δείτε τους επισκέπτες σας και να πραγματοποιήσετε εξαγωγή σε excel. Η πρόσβαση στο portal της έκθεσης είναι διαθέσιμη για 7 μέρες μετά το τέλος της έκθεσης.',
			'Advertisement Logo': 'Διαφημιστικό Logo',
			'Advertisement Logo With Kiosk Information': 'Διαφημιστικό Logo Με Πληροφορίες Περιπτέρου',
			'Download Logo': 'Λήψη Logo',
			'Marketing Kit has not been uploaded yet from exhibition organizer.': 'Το Marketing Kit δεν είναι διαθέσιμο ακόμα από τον οργανωτή της έκθεσης.',
			'Display Marketing Kit And Advertisement Logos Tab To Exhibitor': 'Εμφάνιση Marketing Kit Και Διαφημιστικών Logo Στους Εκθέτες',
			'Display Free Advertisement Tab To Exhibitor': 'Εμφάνιση Διαφημιστικής Καταχώρησης Στους Εκθέτες',
			'If you disable this, then exhibitors will not be able to access Marketing Kit and advertisement logos from their profile.': 'Εάν το απενεργοποιήσετε, τότε οι εκθέτες δεν θα έχουν πρόσβαση στο Marketing Kit και στα διαφημιστικά logo.',
			'If you disable this, then exhibitors will not be able to access free advertisement from their profile.': 'Εάν το απενεργοποιήσετε, τότε οι εκθέτες δεν θα έχουν πρόσβαση στην Διαφημιστική Καταχώρηση.',
			'Marketing Kit': 'Marketing Kit',
			'Advertisement Logos': 'Διαφημιστικά Logos',
			'Download Exhibitor Advertisement Logos As Single Zip File': 'Λήψη όλων των διαφημιστικών logo των εκθετών σε ένα zip αρχείο',
			'You can only upload a single file. Please remove your old file to upload again!': 'Επιτρέπεται να ανεβάσετε μόνο ένα αρχείο. Παρακαλώ διαγράψτε το παλιό αρχείο για να μπορέσετε να ξανά πραγματοποιήσετε μεταφόρτωση!',
			'exhibitor_kit_and_logos': 'Μπορείτε να μεταφορτώσετε <strong>ένα</strong> αρχείο για το Marketing Kit.<br/> Επιτρέπονται μόνο <strong>.zip</strong> και <strong>.7z</strong> αρχεία.',
			'Marketing Kit & Advertisement Logos': 'Marketing Kit & Διαφημιστικά Logos',
			'Flag as new': 'Επισήμανση ως νέο',
			'Catalogue Language': 'Γλώσσα Καταλόγου',
			'Select if catalogue will be displayed in english, greek or both languages.': 'Επιλογή γλώσσας καταλόγου σε μόνο ελληνικά, μόνο αγγλικά ή σε 2 γλώσσες',
			'English & Greek': 'Ελληνικά & Αγγλικά',
			'Rules': 'Κανόνες',
			'Characterization': 'Χαρακτηρισμός',
			'Visitor Registration': 'Registration Επισκέπτη',
			'Transfer Successful!': 'Επιτυχής Μεταφορά!',
			'Catalogue Only In English Language': 'Κατάλογος Μόνο Στα Αγγλικά',
			'If enabled exhibition and catalogue will only appear in English language.': 'Με την ενεργοποίηση της επιλογής, ο κατάλογος εκθέτη θα εμφανίζεται μόνο στα Αγγλικά και η προεπιλεγμένη γλώσσα της έκθεσης θα είναι Αγγλικά.',
			"Disable Registration Messages": "Απενεργοποίηση Αποστολής Μηνυμάτων Στο Registration",
			"Display Preregistration Form Fields In Groups": "Εμφάνιση Πεδίων Preregistration σε Γκρουπ.",
			'If enabled fields of preregistration form are grouped under two groups. You can set a specific group for each field in Field Settings.': 'Με την ενεργοποίηση της επιλογής, τα πεδία της φόρμας του preregistration εμφανίζονται ομαδοποιημένα σε δύο γκρουπ. Μπορείτε να ορίσετε το γκρουπ του κάθε πεδίου στις Ρυθμίσεις Πεδίων',
			'If enabled emails and SMS are not sent after registering a visitor.': 'Με την ενεργοποίηση της επιλογής, απενεργοποιείτε η αποστολή email και SMS κατά την εγγραφή ενός επισκέπτη.',
			"Printing... Please don't close the browser before the process ends.": "Πραγματοποιείτε εκτύπωση... Παρακαλώ μην κλείσετε το παράθυρο του browser πριν να τελειώσει η διαδικασία.",
			'Date where catalog becomes non editable': 'Ημερομηνία όπου ο κατάλογος γίνετε μη επεξεργάσιμος',
			'Import from excel': 'Εισαγωγή από excel',
			'Quick Print Visitor Badges': 'Γρήγορη Εκτύπωση Badges Επισκεπτών',
			'Activate Type (applies for English and Greek)': 'Ενεργοποίηση Τύπου (ισχύει για Αγγλικά και Ελληνικά)',
			'Actions': 'Ενέργειες',
			'User': 'Χρήστης',
			'Visible on registration form': 'Ορατό στη φόρμα του registration',
			'Visitor Categories': 'Κατηγορίες Επισκεπτών',
			'Add Column': 'Προσθήκη Στήλης',
			'Add Row': 'Προσθήκη Γραμμής',
			'Visitor': 'Επισκέπτης',
			'Fields': 'Πεδία',
			'Business Categories': 'Επαγγελματικές κατηγορίες',
			'Show kiosk sign': 'Προβολή μετόπης',
			'Enable B2B': 'Ενεργοποίηση B2B',
			'Menu': 'Μενού',
			'Copied': 'Αντιγράφηκε',
			'This is the public url that visitors should follow in order to complete their preregistration.': 'Αυτή είναι η διεύθυνση url που πρέπει να ακολουθήσουν οι επισκέπτες προκειμένου να ολοκληρώσουν την προεγγραφή τους.',
			'Only unauthenticated users can access this link.': 'Μόνο μη πιστοποιημένο`ι χρήστες μπορούν να έχουν πρόσβαση σε αυτόν τον σύνδεσμο.',
			'Copy': 'Αντιγραφή',
			'Note': 'Σημείωση',
			'Uploading': 'Μεταφόρτωση',
			'Reports': 'Αναφορές',
			'Entrance Time': 'Ώρα εισόδου',
			'Entries per Time': 'Είσοδοι ανά Χρόνο',
			'Print Paper Size': 'Μέγεθος Χαρτιού Εκτύπωσης',
			'Registration Print Paper Size': 'Μέγεθος Χαρτιού Εκτύπωσης Registration',
			'Label': 'Ετικέτα',
			'Frequently Asked Questions': 'Συχνές Ερωτήσεις',
			'Text': 'Κείμενο',
			'Added successfully': 'Προστέθηκε επιτυχώς',
			'Partner added successfully': 'Ο συνεργάτης προστέθηκε με επιτυχία',
			'By enabling this option organizers will have to approve/reject users, after they complete their preregistration.': 'Με την ενεργοποίηση αυτής της επιλογής, οι διοργανωτές θα πρέπει να εγκρίνουν/απορρίπτουν τους χρήστες, αφού ολοκληρώσουν την προεγγραφή τους.',
			'Preregistration Requires Approval': 'To preregistration απαιτεί έγκριση',
			'Mobile Phone': 'Κινητό Τηλέφωνο',
			'Search visitor': 'Εύρεση επισκέπτη',
			'Allow Multiple Selection': 'Να επιτρέπεται η πολλαπλή επιλογή',
			'Logout': 'Έξοδος',
			'Account settings': 'Ρυθμίσεις λογαριασμού',
			'status_1': 'Ολοκληρωμένο',
			'status_2': 'Επερχόμενο',
			'status_3': 'Σε εξέλιξη',
			'Clear': 'Καθαρισμός',
			'PAGE NOT FOUND': 'Η ΣΕΛΙΔΑ ΔΕΝ ΒΡΕΘΗΚΕ',
			'Currently there are no active exhibitions': 'Δεν βρέθηκαν ενεργές εκθέσεις',
			'Field must be checked': 'Παρακαλούμε επιλέξτε το πεδίο',
			'Select at least one': 'Επιλέξτε τουλάχιστον ένα',
			'Visitor added successfully': 'Ο επισκέπτης προστέθηκε με επιτυχία',
			'Visitor updated successfully': 'Ο επισκέπτης ενημερώθηκε με επιτυχία',
			'Interests': 'Επαγγελματική Ιδιότητα',
			'Countries': 'Χώρα',
			'This list is visible to exhibitors/visitors when prompted to select their interests.': 'Αυτή η λίστα είναι ορατή στους εκθέτες/επισκέπτες όταν τους ζητηθεί να επιλέξουν τα ενδιαφέροντά τους.',
			'This list is visible to exhibitors/visitors when prompted to select their business categories.': 'Αυτή η λίστα είναι ορατή στους εκθέτες/επισκέπτες όταν τους ζητηθεί να επιλέξουν τις επαγγελματικές τους κατηγορίες.',
			'Add a visitor': 'Προσθήκη επισκέπτη',
			'Add visitor category': 'Προσθήκη κατηγορίας επισκέπτη',
			'Edit visitor category': 'Επεξεργασία κατηγορίας επισκέπτη',
			'Select Exhibition': 'Επιλέξτε Έκθεση',
			'Send badges': 'Αποστολή badge',
			'Sent {{count}} emails  successfully': 'Στάλθηκαν {{count}} email με επιτυχία',
			'{{count}} emails will be sent': '{{count}} emails θα σταλούν',
			'required': 'Υποχρεωτικό πεδίο',
			'Required': 'Υποχρεωτικό πεδίο',
			'File is required': 'Υποχρεωτικό ανέβασμα αρχείου',
			'Enter a valid email': 'Εισαγάγετε ένα έγκυρο email',
			'Enter a valid phone between 8 and 15 digits': 'Εισαγάγετε ένα έγκυρο τηλέφωνο 8 με 15 ψηφίων.',
			'Enter a valid mobile phone': 'Εισαγάγετε ένα έγκυρο κινητό τηλέφωνο',
			'Confirm': 'Επιβεβαίωση',
			'Next Step': 'Επόμενο Βήμα',
			'Previous Step': 'Προηγούμενο Βήμα',
			'Send': 'Αποστολή',
			'An email will be sent to the following address(es)': 'Θα σταλεί ένα email στις ακόλουθες διευθύνσεις',
			'send_form_step_2': 'Γράψτε την διεύθυνση email στην οποία θα αποσταλεί το συγκεντρωτικό αρχείο.',
			'Select Email': 'Επιλογή Διεύθυνσης Email',
			'Select Action': 'Επιλογή Ενέργειας',
			'Action to perform': 'Επιλογή Ενέργειας',
			'Generate consolidated file and send to one person': 'Δημιουργία ενοποιημένου αρχείου και αποστολή σε ένα άτομο',
			'Send email to everyone': 'Αποστολή email σε όλους',
			'send_form_step_1': 'Μπορείτε να επιλέξετε είτε να στείλετε ένα email ρητά σε όλους τους χρήστες που επιλέξατε νωρίτερα, είτε μπορείτε να δημιουργήσετε ένα συγκεντρωτικό αρχείο το οποίο θα σταλεί σε μια διεύθυνση email που καθορίσετε σε επόμενο βήμα. Αυτό μπορεί να είναι χρήσιμο εάν θέλετε να εκτυπώσετε/διανείμετε μόνοι σας τις προσκλήσεις ή τα badges.',
			'Partner removed successfully': 'Ο συνεργάτης αφαιρέθηκε με επιτυχία',
			'Partner already exists': 'Ο συνεργάτης υπάρχει ήδη',
			'Visitor removed successfully!': 'Ο επισκέπτης διαγράφηκε με επιτυχία!',
			'Profile updated successfully': 'Το προφίλ ενημερώθηκε με επιτυχία',
			'Exhibition updated successfully': 'Η έκθεση ενημερώθηκε με επιτυχία',
			'This action is permanent. Press OK if you want to proceed.': 'Αυτή η ενέργεια είναι μόνιμη. Πατήστε OK εάν θέλετε να συνεχίσετε.',
			'Confirm Delete': 'Επιβεβαίωση Διαγραφής',
			'Text Color': 'Χρώμα κειμένου',
			'Background Color': 'Χρώμα φόντου',
			'Display Visitor Label In Badge': 'Εμφάνιση Ετικέτα Επισκέπτη Στο Badge',
			'Display Badge Only In English': 'Εμφάνιση Badge Μόνο Στα Αγγλικά',
			'Visible In Preregistration': 'Εμφάνιση Στην Φόρμα Προεγγραφής',
			'Visible To Organizer': 'Εμφάνιση Στον Οργανωτή',
			'English Category Description': 'Αγγλική Περιγραφή Κατηγορίας',
			'Greek Category Description': 'Ελληνική Περιγραφή Κατηγορίας',
			'English Category Explanation': 'Αγγλική Επεξήγηση Κατηγορίας',
			'Greek Category Explanation': 'Ελληνική Επεξήγηση Κατηγορίας',
			'No categories yet': 'Δεν υπάρχουν ακόμη κατηγορίες',
			'Click the button bellow to enter visitor categories.': 'Κάντε κλικ στο κουμπί παρακάτω για να εισαγάγετε τις κατηγορίες επισκεπτών.',
			'Add': 'Προσθήκη',
			'Color': 'Χρώμα',
			'Design': 'Σχεδιασμός',
			'Categories': 'Κατηγορίες',
			'Preview': 'Προεπισκόπηση',
			'No description yet': 'Δεν έχει συμπληρωθεί η περιγραφή ακόμα',
			"Description": 'Περιγραφή',
			"Drag 'n' drop some files here, or click to select files": 'Σύρετε και αποθέστε μερικά αρχεία εδώ ή κάντε κλικ για να επιλέξετε αρχεία',
			'Uploaded File(s)': 'Ανεβασμένα Αρχεία',
			'Selected File(s)': 'Επιλεγμένα Αρχεία',
			'Download File': 'Κατέβασμα Αρχείου',
			'Download': 'Κατέβασμα',
			'Delete': 'Διαγραφή',
			'Greek Description': 'Ελληνική Περιγραφή',
			'English Description': 'Αγγλική περιγραφή',
			'NO WELCOME PAGE': 'ΔΕΝ ΥΠΑΡΧΕΙ ΣΕΛΙΔΑ ΚΑΛΩΣΟΡΙΣΜΑΤΟΣ',
			'here': 'εδώ',
			'You can edit this exhibition\'s welcome screen': 'Μπορείτε να επεξεργαστείτε την οθόνη καλωσορίσματος αυτής της έκθεσης',
			'Catalogue': 'Κατάλογος',
			'Catalogue Locked': 'Κλείδωμα Καταλόγου',
			'If you enable this, then exhibitors will not be able to edit their catalogue information. However they will be able to view them. Organizers will not be able to edit exhibitor catalogues either. Catalogues can only be updated from EnterSoft data transfer.': 'Εάν το ενεργοποιήσετε, τότε οι εκθέτες δεν θα μπορούν να επεξεργαστούν τις πληροφορίες του καταλόγου τους. Ωστόσο, θα μπορούν να τις δουν. Οι οργανωτές επίσης δεν θα μπορούν να επεξεργαστούν τους καταλόγους εκθετών. Οι κατάλογοι ενημερώνονται μόνο κατά τη μεταφορά δεδομένων από το EnterSoft.',
			'Number of partners per exhibitor': 'Αριθμός συνεργατών ανά εκθέτη',
			'Limit the number of partners an exhibitor can invite. Leave empty to allow infinite number of partners.': 'Περιορίστε τον αριθμό των συνεργατών που μπορεί να προσκαλέσει ένας εκθέτης. Αφήστε κενό για να επιτρέψετε άπειρο αριθμό συνεργατών.',
			'Logo': 'Λογότυπο',
			'Badge Logo': 'Λογότυπο Badge',
			'Badge logo removed successfully!': 'Το λογότυπο του badge διαγράφηκε με επιτυχία!',
			'Logo removed successfully!': 'Το λογότυπο διαγράφηκε με επιτυχία!',
			'Failed to remove logo!': 'Η διαγραφή του λογότυπος απέτυχε!',
			'Failed to remove badge logo!': 'Η διαγραφή του λογότυπος του badge απέτυχε!',
			'Image removed successfully!': 'Η εικόνα διαγράφηκε με επιτυχία!',
			'Failed to remove image!': 'Η διαγραφή της εικόνας απέτυχε!',
			'Prereg. Background Image': 'Υπόβαθρο Προεγγραφής',
			'Number of days before catalogue becomes non editable': 'Αριθμός ημερών πριν ο κατάλογος γίνει μη επεξεργάσιμος',
			'Exhibitors will not be able to update their catalog profile after the date specify here. Organizers will still be able to update exhibitor catalogues after this date.': 'Οι εκθέτες δεν θα μπορούν να ενημερώσουν το προφίλ του καταλόγου τους μετά από την ημερομηνία που προσδιορίζετε εδώ. Οι οργανωτές θα μπορούν ακόμα να ενημερώσουν τους καταλόγους των εκθετών μετά από αυτήν την ημερομηνία.',
			'Customize': 'Σχεδιασμός',
			'Customize, Visitor Categories And Special Rules': 'Σχεδιασμός, Κατηγορίες Επισκεπτών Και Ειδικοί Κανόνες',
			'Email/SMS Text Creation': 'Δημιουργία Κειμένων Email/SMS',
			'Enter details about the event and files you want to display to exhibitors.': 'Εισαγάγετε λεπτομέρειες σχετικά με την εκδήλωση και τα αρχεία που θέλετε να εμφανίσετε στους εκθέτες.',
			'Start': 'Έναρξη',
			'General': 'Γενικές',
			'End': 'Λήξη',
			'to': 'έως',
			'Enabled': 'Ενεργοποιημένο',
			'Enable preregistration': 'Ενεργοποίηση preregistration',
			'Preregistration Dates': 'Ημερομηνίες προεγγραφής',
			'Set the date range when preregistration is allowed.': 'Ορίστε το εύρος ημερομηνιών κατά το οποίο επιτρέπεται η προεγγραφή.',
			'Field Settings': 'Ρυθμίσεις πεδίων',
			'Customize preregistration form layout, enabled-disabled fields etc': 'Προσαρμόστε τη διάταξη της φόρμας προεγγραφής, τα ενεργοποιημένα-απενεργοποιημένα πεδία κλπ',
			'Visible on confirmation display': 'Εμφανίζεται στην οθόνη επιβεβαίωσης',
			'Visible on preregistration form': 'Εμφάνιση στην φόρμα προεγγραφής',
			'Disable this option if you want to hide this field from visitor display after a badge is scanned.': 'Απενεργοποιήστε αυτήν την επιλογή εάν θέλετε να αποκρύψετε αυτό το πεδίο από την οθόνη προβολής των στοιχείων των επισκεπτών μετά τη σάρωση ενός σήματος.',
			'Menu not configured yet': 'Το μενού δεν έχει διαμορφωθεί ακόμα',
			'Topic body for language {{language}} not configured yet.': 'Το περιεχόμενο του θέματος για τη γλώσσα {{language}} δεν έχει οριστεί ακόμα.',
			'Topic body not configured yet.': 'Το περιεχόμενο του θέματος δεν έχει οριστεί ακόμα.',
			'You can create your first topic by clicking the button below.': 'Μπορείτε να δημιουργήσετε το πρώτο σας θέμα κάνοντας κλικ στο κουμπί παρακάτω.',
			'Add topic': 'Προσθήκη Θέματος',
			'Greek': 'Ελληνικά',
			'English': 'Αγγλικά',
			'Attachments': 'Συνημμένα',
			'Status': 'Κατάσταση',
			'Title': 'Τίτλος',
			'FILTER BY': 'ΦΙΛΤΡΑ',
			read_more: 'ΕΙΣΟΔΟΣ',
			'Welcome Page': 'Σελίδα Καλωσορίσματος',
			'FAQs': 'Συχνές Ερωτήσεις',
			'Save': 'Αποθήκευση',
			'New Visitor': 'Εγγραφή',
			'Send SMS/Email': 'Αποστολή SMS/Email',
			'Clear Form After Submit': 'Καθαρισμός φόρμας μετά την υποβολή',
			'Update': 'Ενημέρωση',
			'Edit': 'Επεξεργασία',
			'Cancel': 'Ακύρωση',
			'Remove': 'Αφαίρεση',
			'Useful Files': 'Χρήσιμα Αρχεία',
			'Details': 'Λεπτομέρειες',
			'Exhibitors': 'Εκθέτες',
			'Visitors': 'Επισκέπτες',
			'Settings': 'Ρυθμίσεις',
			'Company profile group': 'Στοιχεία Εταιρείας',
			'Personal profile group': 'Προσωπικά Στοιχεία',
			'Country': 'Χώρα',
			'Exhibition KPIs': 'KPIs Έκθεσης',
			'Coorganization KPIs': 'KPIs Συνδιοργάνωσης',
			
			'erpTotalCount': 'Επισκέπτες Εισαγόμενοι Από ERP',
			'erpVisitorCount': 'Επισκέπτες Εισαγόμενοι Από ERP Που Προσήλθαν',
			'notErpTotalCount': 'Επισκέπτες Εκτός ERP',
			'notErpVisitorCount': 'Επισκέπτες Εκτός ERP Που Προσήλθαν',
			'preregistrationTotalCount': 'Επισκέπτες Καταχωρημένοι Μέσω Προεγγραφής',
			'preregistrationVisitorCount': 'Επισκέπτες Καταχωρημένοι Μέσω Προεγγραφής Που Προσήλθαν',
			
			'erpTotalCountCoorg': 'Επισκέπτες Εισαγόμενοι Από ERP',
			'erpVisitorCountCoorg': 'Επισκέπτες Εισαγόμενοι Από ERP Που Προσήλθαν',
			'notErpTotalCountCoorg': 'Επισκέπτες Εκτός ERP',
			'exhibitorScanners': 'Εκθέτες Που Χρησιμοποίησαν Σάρωση',
			'notErpVisitorCountCoorg': 'Επισκέπτες Εκτός ERP Που Προσήλθαν',
			'preregistrationTotalCountCoorg': 'Επισκέπτες Καταχωρημένοι Μέσω Προεγγραφής',
			'preregistrationVisitorCountCoorg': 'Επισκέπτες Καταχωρημένοι Μέσω Προεγγραφής Που Προσήλθαν',
			
			'scannedAfterRegistration': 'Επισκέπτες Σκαναρισμένοι Μετά Από Registration',
			
			'Total Entries': 'Σύνολο Εισόδων',
			'EntranceLobby1Count': 'Σαρώσεις Lobby 1',
			'EntranceLobby2Count': 'Σαρώσεις Lobby 2',
			'EntranceLoungeCount': 'Σαρώσεις Delegation Lounge',
			'EntranceEvent1Count': 'Σαρώσεις Event 1',
			'EntranceEvent2Count': 'Σαρώσεις Event 2',
			'EntranceEvent3Count': 'Σαρώσεις Event 3',
			'EntranceEvent4Count': 'Σαρώσεις Event 4',
			'EntranceEvent5Count': 'Σαρώσεις Event 5',
			'EntranceCount': 'Συνολικές Σαρώσεις',
			'VisitorCount': 'Σύνολο Επισκεπτών Που Εισήλθαν',
			'Entries per Date': 'Είσοδοι Ανά Ημερομηνία',
			'EntranceDate': 'Ημερομηνία',
			'Entries per Hour': 'Είσοδοι Ανά Ώρα',
			'EntranceTime': 'Ώρα',
			'Entries per Half Hour': 'Είσοδοι Ανά Μισάωρο',
			'Entries per Region': 'Είσοδοι Ανά Περιοχή',
			'Region': 'Περιοχή',
			'Entries per Country': 'Είσοδοι Ανά Χώρα',
			'VisitorPercentage': 'Ποσοστό Επισκεπτών',
			'EXPORT DATA': 'ΕΞΑΓΩΓΗ ΔΕΔΟΜΕΝΩΝ ΕΠΙΣΚΕΠΤΩΝ ΕΚΘΕΣΗΣ',
			'Coorganization Scans': 'Συνολικές Σαρώσεις Συνδιοργάνωσης',
			'Exhibition Scans': 'Συνολικές Σαρώσεις Έκθεσης',
			'Number of scans for default partner badge.': 'Αριθμός σαρώσεων για το προκαθορισμένο badge συνεργάτη.',
			'Default Partner Badge Scans': 'Σαρώσεις Προκαθορισμένου Badge Συνεργάτη',
			'reports_statistics': 'Στην παρούσα σελίδα μπορείτε να δείτε μία σύνοψη των <strong>στατιστικών</strong> της έκθεσης.<br/> Στο τέλος της έκθεσης μπορείτε να πραγματοποιήσετε <strong>εξαγωγή</strong> των επισκεπτών της έκθεσης σε excel και να χρησιμοποιήσετε το excel για να <strong>εισάγετε</strong> τους επισκέπτες στο ERP σας.<br/> Εάν η έκθεση αποτελεί μέρος συνδιοργάνωσης, το excel περιλαμβάνει τους επισκέπτες από όλες τις εκθέσεις της συνδιοργάνωσης. (Επισκέπτες με ίδια δεδομένα, εμφανίζονται μόνο μία φορά στο excel.)<br/><br/><strong>Οι επισκέπτες που σαρώθηκαν αφού πέρασαν από το Registration, μπορεί να περιέχουν και επισκέπτες που αρχικά είχαν συμπληρώσει τη φόρμα προεγγραφής!</strong><br/><br/><strong>Σύνολο Επισκεπτών</strong> = <strong>Επισκέπτες Εισαγόμενοι Από ERP Που Προσήλθαν</strong> + <strong>Επισκέπτες Εκτός ERP Που Προσήλθαν</strong>',
			
			'erpTotalCount_info': 'Επισκέπτες που έχουν εισαχθεί στο Portal μέσω excel και έχουν ERPId (EnterSoft).',
			'erpVisitorCount_info': 'Από τους επισκέπτες που έχουν εισαχθεί στο Portal μέσω excel και έχουν ErpId, πόσοι από αυτούς έχουν έρθει στην έκθεση. (έχουν σαρωθεί τα badges τους)',
			'notErpTotalCount_info': 'Επισκέπτες που έχουν εισαχθεί στο Portal με οποιονδήποτε τρόπο και δεν έχουν ERPId.',
			'notErpVisitorCount_info': 'Από τους επισκέπτες που δεν έχουν ERPId πόσοι έχουν έρθει στην έκθεση. (έχουν σαρωθεί τα badges τους)',
			'preregistrationTotalCount_info': 'Αριθμός επισκεπτών που συμπλήρωσε τη φόρμα προεγγραφής.',
			'preregistrationVisitorCount_info': 'Από τους επισκέπτες που συμπλήρωσαν τη φόρμα προεγγραφής, πόσοι ήρθαν στην έκθεση. (έχουν σαρωθεί τα badges τους)',
			'scannedAfterRegistration_info': 'Αριθμός επισκεπτών που σαρώθηκε το badge τους αφού πρώτα πέρασαν από το Registration.',
			'erpTotalCountCoorg_info': 'Επισκέπτες που έχουν εισαχθεί στο Portal μέσω excel και έχουν ERPId (EnterSoft).',
			'erpVisitorCountCoorg_info': 'Από τους επισκέπτες που εισαχθεί στο Portal μέσω excel και έχουν ErpId, ποιοι από αυτούς έχουν έρθει στην έκθεση. (έχουν σαρωθεί τα badges τους)',
			'notErpTotalCountCoorg_info': 'Επισκέπτες που έχουν εισαχθεί στο Portal με οποιονδήποτε τρόπο και δεν έχουν ERPId',
			'exhibitorScanners_info': 'Αριθμός εκθετών που χρησιμοποίησαν τη δυνατότητα σάρωσης επισκεπτών από τα περίπτερά τους.',
			'notErpVisitorCountCoorg_info': 'Από τους επισκέπτες που δεν έχουν ERPId ποιοι έχουν έρθει στην έκθεση. (έχουν σαρωθεί τα badges τους)',
			'preregistrationTotalCountCoorg_info': 'Αριθμός επισκεπτών που συμπλήρωσε τη φόρμα προεγγραφής.',
			'preregistrationVisitorCountCoorg_info': 'Από τους επισκέπτες που συμπλήρωσαν τη φόρμα προεγγραφής, πόσοι ήρθαν στην έκθεση. (έχουν σαρωθεί τα badges τους)',
			'Total Visitors = Actual Visits From Visitors Submitted Through ERP + Actual Visits From Non ERP Submitted Visitors': 'Σύνολο Επισκεπτών = Επισκέπτες Εισαγόμενοι Από ERP Που Προσήλθαν + Επισκέπτες Εκτός ERP Που Προσήλθαν',
			'VisitorPercentage_info': 'Ποσοστό επισκεπτών από τους συνολικούς που έχουν τον συγκεκριμένο χαρακτηρισμό.',
			'Total Number Of Actual Visitors': 'Πραγματικό Σύνολο Μοναδικών Επισκεπτών Που Προσήλθαν',
			
			'messageTemplateType': 'Τύπος Email/SMS',
			'Sent Email/SMS List And Resends': 'Λίστα Απεσταλμένων Email/SMS Και Επαναποστολές',
			'Email/SMS List': 'Λίστα Email/SMS',
			'Resends Per Date': 'Επαναποστολές Ανά Ημέρα',
			'Exhibitor Invites Visitors With Barcode': 'Πρόσκληση Από Εκθέτη Σε Επισκέπτη Με Barcode',
			'If you disable this, then when exhibitors sends visitors an invitation, barcode will not be included as pdf in the email.': 'Εάν το απενεργοποιήσετε, τότε η πρόσκληση των επισκεπτών από έναν εκθέτη δεν θα περιέχει το barcode σε pdf.',
			'Display Visitors Tab To Exhibitor': 'Εμφάνιση Επισκεπτών Στους Εκθέτες',
			'Display Partners Tab To Exhibitor': 'Εμφάνιση Συνεργατών Στους Εκθέτες',
			'If you disable this, then exhibitors will not be able to access visitor list from their profile.': 'Εάν το απενεργοποιήσετε, τότε οι εκθέτες δεν θα έχουν πρόσβαση στη λίστα επισκεπτών.',
			'If you disable this, then exhibitors will not be able to access partner list from their profile.': 'Εάν το απενεργοποιήσετε, τότε οι εκθέτες δεν θα έχουν πρόσβαση στη λίστα συνεργατών.',
			'Display Service Providers Tab To Exhibitor': 'Εμφάνιση Service Providers Στους Εκθέτες',
			'Display Contractors Tab To Exhibitor': 'Εμφάνιση Κατασκευαστών Στους Εκθέτες',
			'If you disable this, then exhibitors will not be able to access service providers list from their profile.': 'Εάν το απενεργοποιήσετε, τότε οι εκθέτες δεν θα έχουν πρόσβαση στη λίστα των Service Providers.',
			'If you disable this, then exhibitors will not be able to access contractors list from their profile.': 'Εάν το απενεργοποιήσετε, τότε οι εκθέτες δεν θα έχουν πρόσβαση στη λίστα των Κατασκευαστών.',
			'Visitor Category Submitted': 'Η κατηγορία επισκέπτη δημιουργήθηκε.',
			'Visitor Category Submit Failed': 'Η δημιουργία κατηγορίας επισκέπτη απέτυχε.',
			'Visitor Category Updated': 'Η κατηγορία επισκέπτη ενημερώθηκε.',
			'Visitor Category Update Failed': 'Η ενημέρωση κατηγορίας επισκέπτη απέτυχε.',
			'Visitor Category Deleted': 'Η κατηγορία επισκέπτη διαγράφηκε.',
			'Visitor Category Delete Failed': 'Η διαγραφή κατηγορίας επισκέπτη απέτυχε.',
			'Partner Color 1': 'Υπόβαθρο Ετικέτας Συνεργάτη',
			'Partner Color 2': 'Κείμενο Ετικέτας Συνεργάτη',
			'Font Color': 'Γενικό Κείμενο Badge',
			'Visitor Color 1': 'Υπόβαθρο Ετικέτας Επισκέπτη',
			'Visitor Color 2': 'Κείμενο Ετικέτας Επισκέπτη',
			'Service Provider Color 1': 'Υπόβαθρο Ετικέτας Service Provider',
			'Service Provider Color 2': 'Κείμενο Ετικέτας Service Provider',
			'Contractor Color 1': 'Υπόβαθρο Ετικέτας Κατασκευαστή',
			'Contractor Color 2': 'Κείμενο Ετικέτας Κατασκευαστή',
			'Exhibition Staff Color 1': 'Υπόβαθρο Ετικέτας Προσωπικού Έκθεσης',
			'Exhibition Staff Color 2': 'Κείμενο Ετικέτας Προσωπικού Έκθεσης',
			'Organizer Color 1': 'Υπόβαθρο Ετικέτας Οργανωτή',
			'Organizer Color 2': 'Κείμενο Ετικέτας Οργανωτή',
			'Partner Print Size': 'Μέγεθος Εκτύπωσης Συνεργάτη',
			'Visitor Print Size': 'Μέγεθος Εκτύπωσης Επισκέπτη',
			'Visitor Registration Print Size': 'Μέγεθος Εκτύπωσης Registration Επισκέπτη',
			'Service Provider Print Size': 'Μέγεθος Εκτύπωσης Service Provider',
			'Contractor Print Size': 'Μέγεθος Εκτύπωσης Κατασκευαστή',
			'Exhibition Staff Print Size': 'Μέγεθος Εκτύπωσης Προσωπικού Έκθεσης',
			'Organizer Print Size': 'Μέγεθος Εκτύπωσης Οργανωτή',
			'Partner': 'Συνεργάτης',
			'Service Provider': 'Service Provider',
			'Contractor': 'Κατασκευαστής',
			'Exhibition Staff': 'Προσωπικό Έκθεσης',
			'Contractors': 'Κατασκευαστές',
			'Organizer': 'Οργανωτής',
			'Preview Badge Type': 'Επιλογή Τύπου Προεπισκόπησης',
			'Catalog Only In English Language': 'Κατάλογος Μόνο Στα Αγγλικά',
			'Redirection Website': 'Ιστοσελίδα Ανακατεύθυνσης',
			'If you enable exhibition and catalog will only appear in English language.': 'Εάν το ενεργοποιήσετε, τότε ο κατάλογος εκθέτη και η έκθεση θα εμφανίζονται μόνο στα Αγγλικά.',
			'Redirect user to specific website after submitting preregistration form.': 'Ανακατεύθυνση του χρήστη σε συγκεκριμένη ιστοσελίδα μετά την υποβολή της φόρμας προεγγραφής.',
			'Visitor Category Field Required In Import': 'Υποχρεωτική Στήλη Κατηγορίας Επισκέπτη',
			'If you enable this, then Characterization Column is required when importing visitors from excel file.': 'Εάν το ενεργοποιήσετε, τότε είναι υποχρεωτική η ύπαρξη στήλης χαρακτηρισμού στο import excel επισκεπτών.',
			
			'Default maximum number of characters in catalog': 'Προκαθορισμένος αριθμός χαρακτήρων καταλόγου',
			'Display Brands': 'Εμφάνιση Brands',
			'If you disable this, then brand entry will now be accessible in exhibitor \'s catalogue.': 'Εάν το απενεργοποιήσετε, τότε οι εκθέτες δεν θα μπορούν να καταχωρήσουν brands στον κατάλογό τους.',
			'Hide Address Info': 'Απόκρυψη Πεδίων Διεύθυνσης',
			'If you enable this, then address fields in exhibitor \'s catalogue will not be accessible.': 'Εάν το ενεργοποιήσετε, τότε οι εκθέτες δεν θα μπορούν να καταχωρήσουν στοιχεία διεύθυνσης στον κατάλογό τους.',
			'Hide Profile Info': 'Απόκρυψη Πεδίου Προφίλ Εταιρείας',
			'If you enable this, then profile in exhibitor \'s catalogue will not be accessible.': 'Εάν το ενεργοποιήσετε, τότε οι εκθέτες δεν θα μπορούν να καταχωρήσουν στοιχεία προφίλ καταλόγου.',
			'Pregistration Active Countries': 'Χώρες ισχύος Preregistration',
			'Select if preregistration is available everywhere, only in Greece or only outside Greece.': 'Επιλέξτε εάν η λειτουργία της προεγγραφής είναι διαθέσιμη στην Ελλάδα μόνο, στο εξωτερικό μόνο ή παντού.',
			'Everywhere': 'Παντού',
			'Greece': 'Ελλάδα',
			'Abroad': 'Εξωτερικό',
			"Test Exhibitor Credentials": "Στοιχεία Σύνδεσης Τεστ Εκθέτη",
			"Password": "Κωδικός",
			"Username": "Όνομα Χρήστη",
			
			"Catalogue confirmed successfully": "Ο κατάλογος επιβεβαιώθηκε επιτυχημένα",
			"Catalogue confirmation failed": "Αποτυχία επιβεβαίωσης καταλόγου",
			"Catalogue confirmation reset successful": "Επιτυχημένη αναίρεση επιβεβαίωσης στοιχείων καταλόγου",
			"Catalogue confirmation reset failed": "Αποτυχία αναίρεσης επιβεβαίωσης στοιχείων καταλόγου",
			
			"Preregistration Approval Type": "Τύπος Έγκρισης Preregistration.",
			"Select the countries that preregistration approval is required.": "Επιλέξτε τις χώρες στις οποίες απαιτείται έγκριση στο preregistration.",
			'No Approval': 'Χωρίς Έγκριση',
			"interest_order": "Με <strong>Διπλό Κλικ</strong> σε ένα κελί της στήλης <strong>Σειρά</strong>, μπορείτε να ορίσετε τη σειρά εμφάνισης κάθε επαγγελματικής ιδιότητας στη φόρμα προεγγραφής. (Μεγαλύτερος αριθμός σειράς συνεπάγεται εμφάνιση πιο χαμηλά στη λίστα.)<br/><br/> Με <strong>Διπλό Κλικ</strong> σε ένα κελί της στήλης <strong>Απόκρυψη Στο Preregistration</strong>, μπορείτε να ορίσετε ποια επαγγελματική ιδιότητα δεν θα εμφανιστεί στη φόρμα προεγγραφής. <br/><br/> Πατήστε <strong>Enter</strong> ή έξω από το κελί που γράψατε για να αποθηκεύσετε τις αλλαγές σας. <br/> ",
			'Info': 'Σημείωση',
			'Code': 'Κωδικός',
			'Order': 'Σειρά',
			'Profession Domains': 'Επαγγελματικές Ιδιότητες',
			'List of profession domains connected to current exhibition. Set appearance order of profession domains for preregistration form.': 'Λίστα των επαγγελματικών ιδιοτήτων της έκθεσης. Επιλογή σειράς εμφάνισης επαγγελματικών ιδιοτήτων στη φόρμα της προεγγραφής.',
			
			'SMS Sender Name': 'Όνομα Αποστολέα SMS',
			"Use alternative sender name for SMS. If field remains empty, default sender name will be used. (Up to 11 latin characters)": 'Χρήση εναλλακτικού ονόματος αποστολέα για αποστολή των sms. Εάν το πεδίο παραμείνει κενό, θα χρησιμοποιηθεί το default όνομα αποστολέα. (Μέχρι 11 λατινικούς χαρακτήρες)',
			'Preregistration Form Header Link': 'Σύνδεσμος για το logo της εφαρμογής preregistration',
			'Set an external link in preregistration form header logo.': 'Εισαγωγή εξωτερικού συνδέσουμε για το logo στην εφαρμογή προεγγραφής.',
			'Preregistration Form Header Logo Link': 'Σύνδεσμος Logo Εφαρμογής Preregistration',
			'SMS sender name must be in Latin characters. Up to 11 characters allowed.': 'Το όνομα αποστολέα SMS πρέπει να περιέχει μόνο λατινικούς χαρακτήρες. Επιτρέπονται μέχρι 11 χαρακτήρες.',
			'Sender Email': 'Email Αποστολέα',
			'Use alternative email to send emails. If field remains empty, default email will be used. Email domain must be declared in Mailchimp services.': 'Χρήση εναλλακτικού email για αποστολή των emails. Εάν το πεδίο παραμείνει κενό, θα χρησιμοποιηθεί το default email. Το domain του email που θα χρησιμοποιηθεί πρέπει να έχει δηλωθεί στο Mailchimp.',
			'Email Sender Name': 'Όνομα Αποστολέα Email',
			'Use alternative sender for emails. If field remains empty, default sender name will be used.': 'Χρήση εναλλακτικού ονόματος αποστολέα για αποστολή των emails. Εάν το πεδίο παραμείνει κενό, θα χρησιμοποιηθεί το default όνομα αποστολέα.',
			"Quick Print Badge": "Γρήγορη Εκτύπωση Badge",
			"quick_badge_info": 'Στην παρούσα σελίδα μπορείτε να κάνετε γρήγορη εκτύπωση <strong>BADGE</strong> προκαθορισμένου υποδείγματος και μεγέθους.<br/> Πατήστε στο κουμπί <strong>ΕΙΣΑΓΩΓΗ ΑΠΟ EXCEL</strong> για να εισάγετε πολλαπλά badges ή συμπληρώστε τη φόρμα για την προσθήκη ενός badge και πατήστε στο κουμπί  <strong>ΕΚΤΥΠΩΣΗ</strong>.<br/><br/><strong>Προτεινόμενες Διαστάσεις Εικόνας Υποσέλιδου: 1000x212.</strong><br/><br/><strong>Προσοχή:</strong> Ακολουθείστε τις οδηγίες για την επιτυχή εκτύπωση badge από excel. Παρακαλώ μην κλείσετε το παράθυρο μέχρι να ολοκληρωθεί η διαδικασία εκτύπωσης.<br/>',
			'Clear Form': 'Καθαρισμός Φόρμας',
			'Name EN': 'Ονοματεπώνυμο EN',
			'Name EL': 'Ονοματεπώνυμο EL',
			'Company Name EN': 'Επωνυμία Εταιρείας / Οργανισμός EN',
			'Company Name EL': 'Επωνυμία Εταιρείας / Οργανισμός EL',
			'Characterization EN': 'Χαρακτηρισμός EN',
			'Characterization EL': 'Χαρακτηρισμός EL',
			'PRINT': 'ΕΚΤΥΠΩΣΗ',
			'Download excel template': 'Κατέβασμα προτύπου excel',
			'Import selected file': 'Εισαγωγή επιλεγμένου αρχείου',
			'Failed to print badge!': 'Αποτυχία εκτύπωσης badge!',
			'Characterization Background Color': 'Χρώμα Φόντου Χαρακτηρισμού',
			'Characterization Text Color': 'Χρώμα Κειμένου Χαρακτηρισμού',
			'optional': 'προαιρετικό',
			'import_excel_msg_quick_print': 'Εάν θέλετε να προσθέσετε περισσότερα από ένα άτομα γρήγορα, μπορείτε να ανεβάσετε ένα αρχείο <strong>Excel</strong>.<br/><ul><li>Το αρχείο excel πρέπει να ακολουθεί τη δομή που περιγράφεται παρακάτω.</li><li>Βεβαιωθείτε ότι οι στήλες σας είναι σε σειρά όπως στον πίνακα του παραδείγματος.</li><li>Για τη διευκόλυνσή σας, μπορείτε επίσης να κάνετε λήψη του κενού προτύπου excel.</li><li>Εάν παραλείψετε να βάλετε χρώματα γραμματοσειράς/υποβάθρου για τον χαρακτηρισμό, μπαίνουν οι προκαθορισμένες τιμές FFFFFF/6D6D6D αντίστοιχα.</li><li>Εάν παραλείψετε την επιλογή μεγέθους εκτύπωσης, η εκτύπωση γίνεται στην προκαθορισμένη τιμή A5.</li></ul>',
			'Print Size': 'Μέγεθος Εκτύπωσης',
			'Activate Taxis Search on Preregistration': 'Ενεργοποίηση Αναζήτησης ΑΦΜ Μέσω TAXIS Στη Φόρμα Προεγγραφής',
			'Enable this option to allow searching Tax Registration Number in TAXIS API on preregistration form.': 'Ενεργοποιώντας αυτήν την επιλογή, μπορείτε να πραγματοποιήσετε αναζήτηση του ΑΦΜ στο TAXIS, στην φόρμα της προεγγραφής.',
			'Activate Taxis Search on Registration': 'Ενεργοποίηση Αναζήτησης ΑΦΜ Μέσω TAXIS Στη Φόρμα Registration',
			'Enable this option to allow searching Tax Registration Number in TAXIS API on registration form.': 'Ενεργοποιώντας αυτήν την επιλογή, μπορείτε να πραγματοποιήσετε αναζήτηση του ΑΦΜ στο TAXIS, στην φόρμα του registration.',
			'Visible on Company Group': 'Εμφάνιση Στο Γκρουπ Πεδίων Της Εταιρίας',
			'Enable this option to place field in Company Group Of Preregistration Form. If disabled field will be placed in Personal Information Group.': 'Ενεργοποιείστε αυτήν την επιλογή, για να εμφανίζεται το πεδίο στο γκρούπ πεδίων Εταιρείας. Εάν απενεργοποιήσετε την επιλογή, το πεδίο θα εμφανιστεί στο Γκρουπ Πεδίων Των Προσωπικών Πληροφοριών.',
			'Footer image uploaded successfully!': 'Η εικόνα για το υποσέλιδο του badge ενημερώθηκε επιτυχώς!',
			'Footer image removed successfully!': 'Η εικόνα για το υποσέλιδο του badge διαγράφηκε επιτυχώς!',
			'Footer Image': 'Εικόνα Υποσέλιδου',
			'Design-and-print-settings': 'Σχεδιασμός Badge & Ρυθμίσεις Εκτύπωσης',
			'Visitor-categories': 'Κατηγορίες Επισκεπτών',
			'Special-badge-rules': 'Ειδικοί Κανόνες Εκτύπωσης',
			'Badge Print Settings': 'Ρυθμίσεις Εκτύπωσης Badge',
			'Visitor Badge Content': 'Κείμενο Badge Επισκέπτη',
			'Partner Badge Content': 'Κείμενο Badge Συνεργάτη',
			'badge-settings': "Σε αυτήν τη σελίδα μπορείτε να αλλάξετε τις <strong>γενικές ρυθμίσεις εκτύπωσης</strong> για τα badges ή να <strong>σχεδιάσετε το περιεχόμενό τους.</strong><br/>Το κείμενο του badge που καταχωρείτε για τους συνεργάτες, χρησιμοποιείται και για τους <strong>service providers</strong>, τους <strong>κατασκευαστές</strong> το <strong>προσωπικό έκθεσης</strong> και τους <strong>οργανωτές</strong>. <br/><br/>Πατήστε <strong>ΑΠΟΘΗΚΕΥΣΗ</strong> για να υποβάλλετε τις αλλαγές των ρυθμίσεων των badges.<br/>",
			'Kiosk Sign Editable': 'Επεξεργάσιμη Μετόπη',
			'Allow exhibitor to edit their kiosk sign. You can disable this feature for specific exhibitors, from exhibitor settings.': 'Εάν ενεργοποιήσετε αυτήν την ρύθμιση, ο εκθέτης θα μπορεί να επεξεργαστεί την μετόπη του. Μπορείτε να απενεργοποιήσετε την επεξεργασία μετόπης, για συγκεκριμένους εκθέτες, μέσω των ρυθμίσεων του εκθέτη.',
			"Date before end of catalogue submission to alert exhibitors": "Ημερομηνία πριν την λήξη υποβολής καταλόγου για αποστολή ενημέρωσης στους εκθέτες",
			"If email type 'Ενημέρωση Καταλόγου' is activated, set here the date before end of catalogue submission, that an automatic e-mail will alert exhibitors.": "Εάν ο τύπος email 'Ενημέρωση Καταλόγου' είναι ενεργός, εισάγετε εδώ τον αριθμό των ημερών πριν τη λήξη υποβολής καταλόγου, όπου θα σταλεί αυτομάτως ενημερωτικό email στους εκθέτες.",
			"Number of days to activate registration before exhibition start": "Αριθμός ημερών για ενεργοποίηση του registration πριν την εκκίνηση της έκθεσης",
			"Number of days to de-activate registration after exhibition end": "Αριθμός ημερών για απενεργοποίηση του registration μετά το τέλος της έκθεσης",
			"Visitors QR Validity Period After Exhibition": "Χρόνος Ισχύος QR Επισκεπτών Μετά Την Έκθεση.",
			"If set, visitors will be able to visit other exhibitions, by using their QR code of this exhibition. QR code will be valid for upcoming exhibitions within the days limit you set after this exhibition.": "Εάν ορίσετε συγκεκριμένο διάστημα ημερών, οι επισκέπτες θα μπορούν να χρησιμοποιήσουν το QR αυτής της έκθεσης σε επόμενες εκθέσεις, οι οποίες θα πραγματοποιηθούν μέσα στο διάστημα ημερών που ορίζετε.",
			'No Profession Domains Found': 'Δεν Βρέθηκαν Επαγγελματικές Ιδιότητες',
			'Hide In Preregistration': 'Απόκρυψη Στο Preregistration',
			'sms-types-warning': '<strong>ΠΡΟΣΟΧΗ: !! ΟΙ ΤΥΠΟΙ SMS ΔΕΝ ΠΡΕΠΕΙ ΝΑ ΠΕΡΙEΧΟΥΝ ΔΙΑΛΥΤΙΚΑ !!</strong> <br/> Ο πάροχος SMS δεν επιτρέπει την αποστολή τους. (π.χ. SMS που περιέχει τη λέξη ΛΑΪΚΗ δε θα μπορέσει να αποσταλεί.)<br/><br/><strong>Η αντιγραφή μεταβλητών μεταξύ διαφορετικών τύπων ενδέχεται να δημιουργήσει σφάλματα!</strong><br/>Για διαφορετικούς τύπους γίνεται χρήση μόνο των διαθέσιμων μεταβλητών από τη λίστα.<br/>(Για παράδειγμα, η μεταβλητή \'Link Qrcode\' δεν μπορεί να χρησιμοποιηθεί στους τύπους SMS. Περιέχει χαρακτήρες που δεν επιτρέπονται στα SMS. Πρέπει να γίνεται χρήστη της μεταβλητής \'Url Qrcode\' από τη λίστα των διαθέσιμων μεταβλητών των τύπων SMS.',
			'Download an exhibition marketing kit': 'Λήψη διαφημιστικού κιτ έκθεσης',
			'NEW': 'ΝΕΟ',
		},
		en: {
			'exhibitor_scan_visitors': 'Here you can scan your visitors.',
			'exhibitor_scanned_visitors': 'Here you can scan your visitors and export to excel. Access to exhibition is available for 7 days after exhibition end.',
			'Message Error (3)': 'Unable to send messages. Please confirm that message type 3 (Invitation to partner) is active and not empty in exhibition settings.',
			'Message Error (1)': 'Unable to send messages. Please confirm that message type 1 (Invitation to exhibitor (username/password)) is active and not empty in exhibition settings.',
			'Message Error (4, 8)': 'Unable to send messages. Please confirm that message type 4 (Preregistration completed (Email)) and/or message type 8 (Preregistration completed (SMS)) are active and not empty in exhibition settings.',
			'Message Error (5)': 'Unable to send messages. Please confirm that message type 5 (Preregistration rejection) is active and not empty in exhibition settings.',
			'Message Error (9)': 'Unable to send messages. Please confirm that message type 9 (Invitation to visitor (from exhibitor)) is active and not empty in exhibition settings. If you are not an organizer, please contact app administrations.',
			'Message Error (10, 11)': 'Unable to send messages. Please confirm that message type 10 (Invitation to visitor (SMS)) and/or message type 11 (Invitation to visitor(Email)) are active and not empty in exhibition settings.',
			"message_type_instructions_1": "Sent by organizers from the exhibitors panel of the exhibition (send to new, send to all, send to selected exhibitors).",
			"message_type_instructions_3": "Sent when the exhibitor or organizer chooses to send invitations to the exhibitor's partners. (It is also sent from the corresponding panels for service providers, contractors, exhibition staff, and organizers.)",
			"message_type_instructions_4": "Sent when the organizer approves a visitor's pre-registration application.",
			"message_type_instructions_5": "Sent when the organizer rejects the visitor who made the pre-registration, if the visitor approval process has been enabled from the exhibition settings.",
			"message_type_instructions_6": "Sent automatically, if the exhibitor notification process has been enabled. Sending takes place at 9 AM, on a specific day before the start of the exhibition, which has been declared in the exhibition settings.",
			"message_type_instructions_7": "Sent when the visitor clicks save on the pre-registration, if the visitor approval process has been enabled from the exhibition settings.",
			"message_type_instructions_8": "Sent when the organizer approves a visitor's pre-registration application.",
			"message_type_instructions_9": "Sent in the following cases, regardless of whether the pre-registration process is enabled.<ul><li>When an exhibitor sends an invitation to their visitors from their visitors panel.</li><li>The organizer enters an exhibitor's profile and clicks send from the exhibitor's visitors panel.</li></ul>",
			"message_type_instructions_10": "Sent in the following cases.<ul><li>Pre-registration is disabled and the organizer sends an invitation to visitors from the visitors panel (to all, to new, to selected visitors).</li><li>Pre-registration is enabled and the organizer sends an invitation to visitors from the exhibition visitors panel, regardless of whether the approval process is active (to all, to new, to selected visitors).</li><li>The organizer imports visitors from Excel, regardless of whether the pre-registration process is enabled.</li></ul>",
			"message_type_instructions_11": "Sent in the following cases.<ul><li>Pre-registration is disabled and the organizer sends to visitors from the exhibition visitors panel (send to all, send to new, send to selected).</li><li>Pre-registration is enabled and the organizer sends to visitors from the exhibition visitors panel, regardless of whether the approval process is active (send to all, send to new, send to selected).</li><li>The organizer imports visitors via Excel (regardless of whether the pre-registration process is enabled).</li></ul>",
			"message_type_instructions_12": "Sent to the email info@rota.gr, when a visitor making pre-registration declares a country outside Greece. The Preregistration process must be enabled from the exhibition settings.",
			"message_type_instructions_13": "Sent during registration at the exhibition center, provided that email notifications are enabled.",
			"message_type_instructions_14": "Sent during registration at the exhibition center, provided that SMS notification is enabled.",
			'Catalogue locked': 'Catalogue editing is now locked!',
			'erpTotalCount_info': 'Visitors imported from excel and have ERPId (EnterSoft).',
			'erpVisitorCount_info': 'Number of visitors with ERPId that actually visited the exhibition. (Their badges have been scanned)',
			'notErpTotalCount_info': 'Visitors submitted in portal, but do not have ERPId.',
			'notErpVisitorCount_info': 'Number of visitors without ERPId, that actually visited the exhibition. (Their badges have been scanned)',
			'preregistrationTotalCount_info': 'Visitors that filled the preregistration form.',
			'preregistrationVisitorCount_info': 'Number of visitors that filled the preregistration form and actually visited the exhibition. (Their badges have been scanned)',
			'scannedAfterRegistration_info': 'Number of visitors with scanned badges after going through Registration.',
			'erpTotalCountCoorg_info': 'Visitors imported from excel and have ERPId (EnterSoft).',
			'erpVisitorCountCoorg_info': 'Number of visitors with ERPId that actually visited the exhibition. (Their badges have been scanned)',
			'notErpTotalCountCoorg_info': 'Visitors submitted in portal, but do not have ERPId.',
			'exhibitorScanners_info': 'Number of exhibitors that used visitor scanning from their kiosk.',
			'notErpVisitorCountCoorg_info': 'Number of visitors without ERPId, that actually visited the exhibition. (Their badges have been scanned)',
			'preregistrationTotalCountCoorg_info': 'Visitors that filled the preregistration form.',
			'preregistrationVisitorCountCoorg_info': 'Number of visitors that filled the preregistration form and actually visited the exhibition. (Their badges have been scanned)',
			
			'VisitorPercentage_info': 'Percentage from total visitors that have the specific characterization.',
			
			'Design-and-print-settings': 'Badge Design & Print Settings',
			'Visitor-categories': 'Visitor Categories',
			'Special-badge-rules': 'Special Print Rules',
			'status_1': 'Closed',
			'status_2': 'Upcoming',
			'status_3': 'Ongoing',
			required: 'Required',
			read_more: 'ENTER',
			send_form_step_1: 'You can choose to either send an email explicitly to all the users you selected earlier, or you can generate one consolidated file which will be sent to an email address you specify here. This might be useful if you want to print/distribute the invitations or badges yourself.',
			send_form_step_2: 'Enter the email address to which the consolidated file will be sent.',
			'Company profile group': 'Company Profile',
			'Personal profile group': 'Personal Profile',
			
			'EXPORT DATA': 'EXPORT VISITOR EXHIBITION DATA',
			
			'erpTotalCount': 'Visitors Submitted From ERP',
			'erpVisitorCount': 'Actual Visits From Visitors Submitted Through ERP',
			'notErpTotalCount': 'Non ERP Visitors Submitted',
			'notErpVisitorCount': 'Actual Visits From Non ERP Submitted Visitors',
			'preregistrationTotalCount': 'Visitors From Preregistration',
			'preregistrationVisitorCount': 'Actual Visits From Preregistration Visitors',
			
			'erpTotalCountCoorg': 'Visitors Submitted From ERP',
			'erpVisitorCountCoorg': 'Actual Visits From Visitors Submitted Through ERP',
			'notErpTotalCountCoorg': 'Non ERP Visitors Submitted',
			'exhibitorScanners': 'Exhibitors That Used Scanning',
			'notErpVisitorCountCoorg': 'Actual Visits From Non ERP Submitted Visitors',
			'preregistrationTotalCountCoorg': 'Visitors From Preregistration',
			'preregistrationVisitorCountCoorg': 'Actual Visits From Preregistration Visitors',
			
			'scannedAfterRegistration': 'Scanned After Registration',
			
			'Exhibition Date': 'Ημερομηνία Έκθεσης',
			
			'Total Entries': 'Total Entries',
			'EntranceLobby1Count': 'Lobby 1 Scans',
			'EntranceLobby2Count': 'Lobby 2 Scans',
			'EntranceLoungeCount': 'Delegation Lounge Scans',
			'EntranceEvent1Count': 'Event 1 Scans',
			'EntranceEvent2Count': 'Event 2 Scans',
			'EntranceEvent3Count': 'Event 3 Scans',
			'EntranceEvent4Count': 'Event 4 Scans',
			'EntranceEvent5Count': 'Event 5 Scans',
			'EntranceCount': 'Total Scans',
			'VisitorCount': 'Number Of Actual Visitors',
			'Entries per Date': 'Entries per Date',
			'EntranceDate': 'Date',
			'Entries per Hour': 'Entries per Hour',
			'EntranceTime': 'Time',
			'Entries per Half Hour': 'Entries per Half Hour',
			'Entries per Region': 'Entries per Region',
			'Region': 'Region',
			'Entries per Country': 'Entries per Country',
			'VisitorPercentage': 'Visitor Percentage',
			
			'messageTemplateType': 'Email/SMS Type',
			'Font Color': 'General Badge Font',
			'Partner Color 1': 'Partner Label Background',
			'Partner Color 2': 'Partner Label Text',
			'Visitor Color 1': 'Visitor Label Background',
			'Visitor Color 2': 'Visitor Label Text',
			'Service Provider Color 1': 'Service Provider Background',
			'Service Provider Color 2': 'Service Provider Label Text',
			'Contractor Color 1': 'Contractor Background',
			'Contractor Color 2': 'Contractor Label Text',
			'Exhibition Staff Color 1': 'Exhibition Staff Background',
			'Exhibition Staff Color 2': 'Exhibition Staff Label Text',
			'Organizer Color 1': 'Organizer Background',
			'Organizer Color 2': 'Organizer Label Text',
			'Show kiosk sign': 'Show stand sign',
		},
	},
	[Namespaces.NAVIGATION]: {
		el: {
			'Home': 'Αρχική',
			'Scan Badge': 'Σάρωση Κωδικού',
			'View Scan Details': 'Προβολή Πληροφοριών Σάρωσης',
			'Logout': 'Έξοδος',
			'Help Center': 'Κέντρο Εξυπηρέτησης',
			'Coorganizations': 'Συνδιοργανώσεις',
			'Catalogue Exports': 'Εξαγωγή Καταλόγων',
			'General Reports': 'Γενικές Αναφορές',
			'EnterSoft Transfer': 'Μεταφορά EnterSoft',
			'Exhibition': 'Η Έκθεση',
			'NEW': 'ΝΕΟ',
		},
		en: {},
	},
	[Namespaces.GENERAL_SETTINGS]: {
		el: {
			'Main Exhibition Settings': 'Ρυθμίσεις Κύριας Έκθεσης Συνδιοργάνωσης',
			'Declare main exhibition for coorganization, to declare email/sms settings.': 'Δηλώστε τη κύρια έκθεση της συνδιοργάνωσης, για να παραμετροποιήσετε τις ρυθμίσεις email/sms.',
			'Coorganization Email/SMS Settings': 'Ρυθμίσεις Email/SMS Συνδιοργάνωσης',
			'Actions': 'Ενέργειες',
			'Edit Coorganization': 'Επεξεργασία Συνδιοργάνωσης',
			'Remove Coorganization': 'Διαγραφή Συνδιοργάνωσης',
			'Description': 'Περιγραφή',
			'Main Exhibition': 'Κύρια Έκθεση Συνδιοργάνωσης',
			'Home': 'Αρχική',
			'Add': 'Προσθήκη',
			'Update Coorganization': 'Ενημέρωση Συνδιοργάνωσης',
			'Create Coorganization': 'Δημιουργία Συνδιοργάνωσης',
			'Confirm Delete': 'Επιβεβαίωση Διαγραφής',
			'This action is permanent. Press OK if you want to proceed.': 'Αυτή η ενέργεια είναι μόνιμη. Πατήστε OK εάν θέλετε να συνεχίσετε.',
			'Select Main Exhibition': 'Επιλογή Κύριας Έκθεσης',
			'Description (EN)': 'Περιγραφή (EN)',
			'Description (EL)': 'Περιγραφή (EL',
			'Exhibitions': 'Εκθέσεις',
			'Save': 'Αποθήκευση',
			'Coorganization updated successfully!': 'Η συνδιοργάνωση ενημερώθηκε επιτυχώς!',
			'Coorganization stored successfully!': 'Η συνδιοργάνωση αποθηκεύτηκε επιτυχώς!',
			'Required': 'Υποχρεωτικό',
			'Select at least 2 exhibitions to create a coorganization.': 'Επιλέξτε τουλάχιστον δύο εκθέσεις για να δημιουργήσετε μία συνδιοργάνωση.',
			'Coorganization removed successfully!': 'Η συνδιοργάνωση διαγράφηκε επιτυχώς!',
			'General Reports': 'Γενικές Αναφορές',
			'Select one or more exhibitions': 'Επιλογή μίας ή παραπάνω εκθέσεων',
			'Sort results by': 'Ταξινόμηση αποτελεσμάτων κατά',
			'Select export language.': "Επιλέξετε τη γλώσσα της εξαγωγής.",
			"Greek": "Ελληνικά",
			"English": "Αγγλικά",
			'Select export filters and press EXPORT.': 'Επιλέξετε φίλτρα και πατήστε ΕΞΑΓΩΓΗ.',
			'Export': 'Εξαγωγή',
			'Reports': 'Αναφορές',
			'Get Reports': 'Προβολή Αναφορών',
			'Country': 'Χώρα',
			'Kiosk': 'Περίπτερο',
			'Exhibitor': 'Εκθέτης',
			'Country Code': 'Κωδικός Χώρας',
			'select at least one exhibition': 'επιλέξτε τουλάχιστον μία έκθεση',
			'Multiple Exhibition Export': 'Εξαγωγή Πολλαπλών Εκθέσεων',
			'General Settings': 'Γενικές Ρυθμίσεις',
			'Coorganizations': 'Συνδιοργανώσεις',
			'EnterSoft Transfer': 'Μεταφορά EnterSoft',
			"Transferring data... Please don't close the browser before the process ends.": "Πραγματοποιείτε μεταφορά... Παρακαλώ μην κλείσετε το παράθυρο του browser πριν να τελειώσει η διαδικασία.",
			"Select Exhibitions": "Επιλογή Εκθέσεων",
			"Description EN": "Περιγραφή Αγγλικά",
			"Description EL": "Περιγραφή Ελληνικά",
			"Fetching coorganizations failed.": "Αποτυχία φόρτωσης συνδιοργανώσεων.",
			"Saving coorganization succeeded.": "Επιτυχία αποθήκευσης συνδιοργάνωσης.",
			"Storing coorganization failed.": "Αποτυχία αποθήκευσης συνδιοργάνωσης.",
			"Updating coorganization succeeded.": "Επιτυχία ενημέρωσης συνδιοργάνωσης.",
			"Updating coorganization failed.": "Αποτυχία ενημέρωσης συνδιοργάνωσης.",
			"Deleting coorganization succeeded.": "Επιτυχία διαγραφής συνδιοργάνωσης.",
			"Deleting coorganization failed.": "Αποτυχία διαγραφής συνδιοργάνωσης.",
			"Exhibition Added To Coorganization Successfully.": "Επιτυχία προσθήκης εκθέσεως σε συνδιοργάνωση.",
			"Failed to Add Exhibition To Coorganization.": "Αποτυχία προσθήκης εκθέσεως σε συνδιοργάνωση.",
			"Exhibition Removed From Coorganization Successfully.": "Επιτυχία διαγραφής εκθέσεως από συνδιοργάνωση.",
			"Failed to Remove Exhibition From Coorganization.": "Αποτυχία διαγραφής εκθέσεως από συνδιοργάνωση.",
			'Quick Badge Print': 'Γρήγορη Εκτύπωση Badge'
		},
		en: {
			"Description EN": "English Description",
			"Description EL": "Greek Description",
		},
	},
	[Namespaces.HEADER_COMPONENT]: {
		el: {
			loading: "Φόρτωση",
			menu: 'ΜΕΝΟΥ',
			news: 'ΕΝΗΜΕΡΩΣΕΙΣ',
			orders: 'ΠΑΡΑΓΓΕΛΙΕΣ',
			products: 'ΠΡΟΙΟΝΤΑ',
			reports: 'ΑΝΑΦΟΡΕΣ',
			store: 'ΚΑΤΑΣΤΗΜΑ',
			logout: 'ΕΞΟΔΟΣ',
			payments_1: 'ONLINE',
			payments_2: 'ΠΛΗΡΩΜΕΣ',
		},
		en: {
			loading: "Loading",
			menu: 'MENU',
			news: 'NEWS',
			latest: 'LATEST',
			orders: 'ORDERS',
			products: 'PRODUCTS',
			reports: 'REPORTS',
			store: 'STORE',
			logout: 'LOGOUT',
			payments_1: 'ONLINE',
			payments_2: 'PAYMENTS',
		},
	},
	[Namespaces.VISITOR_PROFILE]: {
		el: {
			'Email may be incorrect.': 'Το email ενδέχεται να μην είναι σωστό.',
			'Visitor Scanned': 'Πραγματοποιήθηκε Σάρωση',
			'visitor_status_types': '<strong>Κατάσταση επισκέπτη.</strong><ul><li><strong>Καταχωρήθηκε.</strong> 1) Ο επισκέπτης καταχωρήθηκε από τον εκθέτη, είτε μέσω import, είτε από τη φόρμα εισαγωγής. 2) Ο επισκέπτης καταχωρήθηκε από οργανωτή μέσω της φόρμας προσθήκης επισκέπτη. 3) Ο επισκέπτης καταχωρήθηκε με import από οργανωτή στην καρτέλα συγκεκριμένου εκθέτη, και επιλέχθηκε στο import να μην είναι εγκεκριμένοι οι επισκέπτες που θα εισάγει.</li><li><strong>Αποστολή Πρόσκλησης.</strong> Έχει πραγματοποιηθεί αποστολή πρόσκλησης από εκθέτη και το preregistration είναι ενεργοποιημένο στην έκθεση.</li><li><strong>Αποστολή Πρόσκλησης - Διαβάστηκε.</strong> Έχει πραγματοποιηθεί αποστολή πρόσκλησης από τον εκθέτη και έχουμε λάβει επιβεβαίωση από MailChimp ότι το email έχει αποσταλεί επιτυχώς και διαβάστηκε.</li><li><strong>Preregistration - Εκκρεμεί Έγκριση.</strong> Ο επισκέπτης έχει συμπληρώσει την προεγγραφή του και περιμένει να εγκριθεί από τον οργανωτή (είναι ενεργοποιημένη η διαδικασία έγκρισης γενικά ή και σε συγκεκριμένη χώρα).</li><li><strong>Αποστολή Badge - Λήφθηκε.</strong> Ο επισκέπτης πέρασε από το registration στο εκθεσιακό. 2) Η προεγγραφή του επισκέπτη έγινε δεχτή και έχει έρθει επιβεβαίωση από το MailChimp ότι διάβασε το email αποδοχής.</li><li><strong>Preregistration - Απορρίφθηκε.</strong> Η προεγγραφή του επισκέπτη απορρίφθηκε από τον οργανωτή.</li><li><strong>Preregistration - Εγκρίθηκε</strong> 1) Ο οργανωτής έχει δεχτεί την αίτηση προεγγραφής του επισκέπτη. 2) Γίνεται εισαγωγή του επισκέπτη από τον οργανωτή είτε από import είτε από τη φόρμα γρήγορης προσθήκης. 3) Γίνεται αποστολή πρόσκλησης από οργανωτή, με τα buttons στον γενικό πίνακα επισκεπτών. 4) Γίνεται import του επισκέπτη από τον οργανωτή στην καρτέλα συγκεκριμένου εκθέτη και έχει επιλέξει στο import να είναι εγκεκριμένοι αυτομάτως οι επισκέπτες που θα εισάγει. 5) Ο εκθέτης στέλνει πρόσκληση στον επισκέπτη και δεν είναι ενεργοποιημένο το preregistration. 6) Ο επισκέπτης κάνει preregistration και δεν είναι ενεργή η διαδικασία έγκρισης.</li></ul>',
			'Row': 'Γραμμή',
			'Column': 'Στήλη',
			'Disabled': 'Απενεργοποιημένο',
			'Person Number': 'Αριθμός Ατόμων',
			'Person Count': 'Αριθμός Ατόμων',
			'Is individual': 'Ιδιώτης',
			'Has Revisited': 'Έχω ξανά επισκεφθεί την έκθεση',
			'Characterization': 'Χαρακτηρισμός',
			'Visitors': 'Επισκέπτες',
			'VAT Number': 'ΑΦΜ',
			'VAT Taxis': 'Taxis - ΑΦΜ',
			'Visitor Count': 'Αριθμός επισκεπτών',
			'return': 'Επιστροφή',
			'preregistration_upcoming_warning': 'Η προεγγραφή θα ανοίξει στις <bold>{{date}}</bold>.',
			'preregistration_submit_warning': 'Αυτή η φόρμα θα παραμείνει δημόσια μέχρι και την <bold>{{date}}</bold>.',
			'Info': 'Σημείωση',
			'Proceed with your preregistration by filling the form below.': 'Συνεχίστε με την προεγγραφή σας συμπληρώνοντας την παρακάτω φόρμα.',
			'Preregistration is disabled for this exhibition.': 'Η προεγγραφή είναι απενεργοποιημένη για αυτήν την έκθεση.',
			'Save': 'Αποθήκευση',
			status_1: 'Καταχωρήθηκε',
			status_2: 'Αποστολή Πρόσκλησης',
			status_3: 'Αποστολή Πρόσκλησης - Διαβάστηκε',
			status_4: 'Preregistration - Εκκρεμεί Έγκριση',
			status_5: 'Αποστολή Badge',
			status_6: 'Αποστολή Badge - Λήφθηκε',
			status_7: 'Preregistration - Εγκρίθηκε',
			status_8: 'Preregistration - Απορρίφθηκε',
			Loading: "Φόρτωση",
			'Preregistration Information': "Πληροφορίες Προεγγραφής",
			'APPROVE': 'ΕΓΚΡΙΣΗ',
			'APPROVED': 'ΕΓΓΕΚΡΙΜΕΝΟΣ',
			'REJECT': 'ΑΠΟΡΡΙΨΗ',
			'REJECTED': 'ΑΠΟΡΡΙΦΘΗΚΕ',
			'PENDING': 'ΕΚΡΕΜΕΙ ΕΓΚΡΙΣΗ',
			'EVENT INFORMATION': 'ΠΛΗΡΟΦΟΡΙΕΣ ΕΚΘΕΣΗΣ',
			'Comment': 'Σχόλιο',
			'Start Date': 'Ημερομηνία Έναρξης',
			'End Date': 'Ημερομηνία Λήξης',
			'Print': 'Εκτύπωση',
			'Mail': 'Email',
			'Name': 'Ονοματεπώνυμο',
			'Invitations': 'Προσκλήσεις',
			'Surname': 'Επώνυμο',
			'Postal Code': 'Τ.Κ.',
			'Company Name': 'Επωνυμία Εταιρείας / Οργανισμός',
			'Company Firm': 'Φίρμα Εταιρείας',
			'Company Address': 'Διεύθυνση Εταιρείας',
			'Company Website': 'Ηλεκτρονική Σελίδα Εταιρείας',
			'Category': 'Κατηγορία',
			'Interests': 'Επαγγελματική Ιδιότητα',
			'Countries': 'Χώρα',
			'City': 'Πόλη',
			'Phone': 'Τηλέφωνο',
			'Mobile Phone': 'Κινητό Τηλέφωνο',
			'Upload File': 'Ανέβασμα Αρχείου',
			'I agree to terms': 'Συμφωνώ με τους όρους',
			'Register': 'Εγγραφή',
			'Position': 'Θέση / Τμήμα',
			'From Preregistration': 'Από Προεγγραφή',
			'From Registration': 'Από Registration',
			'Invitation Status': 'Αποστολή Πρόσκλησης',
			'Sent': 'Απεσταλμένη',
			'Pending': 'Εκκρεμεί',
			'Confirm Sent': 'Επιβεβαίωση Αποστολής'
		},
		en: {
			'visitor_status_types': "<strong>Visitor Status.</strong><ul><li><strong>Imported.</strong> 1) Exhibitor added a visitor, either by import or visitor form. 2) Organizer added a visitor from visitor form. 3) Organizer imported a visitor through an exhibitor's profile and selected that imported visitors will not be approved automatically. </li><li><strong>Send Invitation.</strong> Visitor invitation was sent by an exhibitor and preregistration is active.</li><li><strong>Send Invitation - Read.</strong> Visitor invitation was sent by an exhibitor and MailChimp has confirmed email was sent and read.</li><li><strong>Preregistration - Pending Approval.</strong>Visitor has submitted their preregistration and is waiting for organizer approval (preregistration approval process is active in general or for specific country).</li><li><strong>Send Badge - Received.</strong> 1) For visitors registered in the exhibition center. 2) Visitor preregistration was accepted by the organizer and MailChimp has confirmed approval email was read.</li><li><strong>Preregistration - Rejected.</strong> Visitor preregistration rejected by the organizer.</li><li><strong>Preregistration - Approved</strong> 1) Organizer approved visitor preregistration. 2) Visitor submitted by the organizer either from import or from quick print visitor badged form. 3)  Organizer sends invitations from the buttons in general visitor table. 4) Organizer imported a visitor through an exhibitor's profile and selected that imported visitors will be automatically approved. 5) Exhibitor sends invitations and preregistration is not active. 6) Visitor goes through preregistration and approval process is not active. </li></ul>",
			status_1: 'Imported',
			status_2: 'Send Invitation',
			status_3: 'Send Invitation - Read',
			status_4: 'Preregistration - Pending Approval',
			status_5: 'Send Badge',
			status_6: 'Send Badge - Received',
			status_7: 'Preregistration - Approved',
			status_8: 'Preregistration - Rejected',
			'Has Revisited': 'I have visited this exhibition more than once',
			'VAT Number': 'Tax Registration Number',
			'VAT Taxis': 'Taxis - Tax Registration Number',
			'Postal Code': 'Postal Code',
			'Company Name': 'Company Name / Organization',
			'Company Firm': 'Company Firm',
			'Company Address': 'Company Address',
			'Company Website': 'Company Website',
			'Category': 'Category',
			'Interests': 'Profession Domain',
			'Countries': 'Country',
			'City': 'City',
			'Phone': 'Phone',
			'Mobile Phone': 'Mobile Phone',
			'Upload File': 'Upload File',
			'I agree to terms': 'I agree to terms',
			'Register': 'Register',
			'Is individual': 'Individual',
			'Position': 'Position / Department'
		},
	},
	[Namespaces.EXHIBITOR_PROFILE]: {
		el: {
			'Email may be incorrect.': 'Το email ενδέχεται να μην είναι σωστό.',
			'Print Badge': 'Εκτύπωση Badge',
			'Open Profile': 'Προφίλ Επισκέπτη',
			'info_catalogue_company_profile': 'Παρακαλούμε να συμπληρώσετε έως {{length}} χαρακτήρες. ',
			'info_catalogue_company_name': 'H ‘‘ΕΠΩΝΥΜΙΑ ΓΙΑ ΤΟΝ ΚΑΤΑΛΟΓΟ’’ θα εμφανίζεται όπου αναγράφονται οι εκθέτες πχ. λίστα εκθετών.',
			'Enter a valid phone between 8 and 15 digits':  'Εισαγάγετε ένα έγκυρο τηλέφωνο 8 με 15 ψηφίων.',
			'Scan will be available during the exhibition.': 'Η σάρωση είναι διαθέσιμη κατά τη διάρκεια της έκθεσης.',
			'Entry updated successfully!': 'Η εγγραφή έχει ενημερώθηκε με επιτυχία!',
			'Entry removed successfully!': 'Η εγγραφή διαγράφηκε επιτυχώς!',
			'Visitor Not Found': 'Δεν βρέθηκε ο επισκέπτης',
			'Scan Visitors': 'Σάρωση Επισκεπτών',
			'My Visitors': 'Οι Επισκέπτες Μου',
			'Allow To Scan Visitors': 'Δυνατότητα Σάρωσης Επισκεπτών',
			'Free Catalogue Advertisement': 'Διαφημιστική Καταχώρηση Καταλόγου',
			'Empty row': 'Κενή στήλη',
			'Deleting visitor on process...': 'Πραγματοποιείται διαγραφή επισκέπτη...',
			'Deleting multiple visitors on process...': 'Πραγματοποιείται διαγραφή επισκεπτών...',
			"Calculating number of emails to send... Please don't close the browser before the process ends.": "Πραγματοποιείται υπολογισμός των emails που θα σταλούν... Παρακαλώ μην κλείσετε το παράθυρο του browser πριν να τελειώσει η διαδικασία.",
			"Creating emails to send... Please don't close the browser before the process ends.": 'Πραγματοποιείται δημιουργία των emails που θα αποσταλούν... Παρακαλώ μην κλείσετε το παράθυρο του browser πριν να τελειώσει η διαδικασία.',
			'Open Exhibitor Catalogue': 'Άνοιγμα Καταλόγου Εκθέτη',
			'Exhibitor Settings': 'Ρυθμίσεις Εκθέτη',
			'Catalogue confirmation can only be done from exhibitors!': 'Η επιβεβαίωση καταλόγου μπορεί να πραγματοποιηθεί μόνο από τους εκθέτες!',
			'Confirm Catalogue Data': 'Επιβεβαίωση Στοιχείων Καταλόγου',
			'Exhibiton': 'Η Έκθεση',
			'Main Actions': 'Βασικές Λειτουργίες',
			'General Info': 'Πληροφορίες',
			'Setup – Operation – Dismantling': 'Προετοιμασία - Λειτουργία - Αποξήλωση',
			'NEW': 'ΝΕΟ',
			'DATA ENTRY FOR GREEK CATALOGUE': 'ΕΙΣΑΓΩΓΗ ΔΕΔΟΜΕΝΩΝ ΕΛΛΗΝΙΚΟΥ ΚΑΤΑΛΟΓΟΥ',
			'DATA ENTRY FOR ENGLISH CATALOGUE': 'ΕΙΣΑΓΩΓΗ ΔΕΔΟΜΕΝΩΝ ΑΓΓΛΙΚΟΥ ΚΑΤΑΛΟΓΟΥ',
			'catalogue_company_name': 'ΕΠΩΝΥΜΙΑ ΓΙΑ ΤΟΝ ΚΑΤΑΛΟΓΟ',
			'catalogue_company_profile': 'ΠΕΡΙΓΡΑΦΗ ΑΝΤΙΚΕΙΜΕΝΟΥ',
			'catalogue_address': 'ΔΙΕΥΘ/ΣΗ',
			'catalogue_city': 'ΠΟΛΗ',
			'catalogue_country': 'ΧΩΡΑ',
			'catalogue_postal': 'Τ.Κ.',
			'catalogue_phone_code': 'ΚΩΔΙΚΟΣ ΤΗΛΕΦΩΝΟΥ ΧΩΡΑΣ',
			'catalogue_phone': 'ΤΗΛ',
			'Export Visitor Grid': 'Εξαγωγή Πίνακα Επισκεπτών',
			'Export Visitors (Marketing)': 'Εξαγωγή Επισκεπτών (Marketing)',
			'Export is based on the columns that are visible on your grid and uses any filters or sorting that are applied in your grid.': 'Η εξαγωγή βασίζεται στις στήλες που είναι ορατές στον πίνακα των επισκεπτών. Επίσης, λαμβάνει υπόψη φίλτρα ή συγκεκριμένη ταξινόμηση που μπορεί να έχετε επιλέξει στον πίνακα.',
			'Failed to export!': 'Αποτυχία εξαγωγής επισκεπτών!',
			'EnterSoft Transfer': 'Μεταφορά EnterSoft',
			'City': 'Πόλη',
			'Import': 'Εισαγωγή',
			'Clear': 'Καθαρισμός',
			'Search': 'Αναζήτηση',
			'General Search': 'Γενική Αναζήτηση',
			'Marketing Kit': 'Marketing Kit - Upload Logo',
			'Catalogue length must be at least 200 characters': 'Το μέγεθος του καταλόγου πρέπει να είναι τουλάχιστον 200 χαρακτήρες',
			'Please fill all required fields to continue!': 'Παρακαλώ αποθηκεύστε όλα τα υποχρεωτικά πεδία για να συνεχίσετε!',
			'VAT Number': 'ΑΦΜ',
			'Please fill all required fields and press "SAVE" before final catalogue confirmation!': 'Παρακαλώ συμπληρώσετε όλα τα απαιτούμενα πεδία και μετά πατήστε "ΑΠΟΘΗΚΕΥΣΗ", πριν την τελική επιβεβαίωση του καταλόγου σας!',
			'From Issue Date': 'Ημερομηνία Έκδοσης Από',
			'To Issue Date': 'Ημερομηνία Έκδοσης Σε',
			'Select export filters and press EXPORT.': 'Επιλέξετε φίλτρα και πατήστε ΕΞΑΓΩΓΗ.',
			'Select date filters optionally and press DOWNLOAD.': 'Επιλέξετε ημερομηνιακά φίλτρα προαιρετικά και πατήστε ΛΗΨΗ.',
			'Upload Date From': 'Ημερομηνία Μεταφόρτωσης Logo Από',
			'Upload Date To': 'Ημερομηνία Μεταφόρτωσης Logo Έως',
			'Download': 'Λήψη',
			'DOWNLOAD CATALOGUE ADVERTISEMENT LOGOS': 'ΛΗΨΗ ΔΙΑΦΗΜΙΣΤΙΚΗΣ ΚΑΤΑΧΩΡΗΣΗΣ ΚΑΤΑΛΟΓΟΥ',
			'DOWNLOAD MARKETING KIT LOGOS': 'ΛΗΨΗ ΔΙΑΦΗΜΙΣΤΙΚOY LOGO MARKETING KIT',
			'Export': 'Εξαγωγή',
			'Kiosk': 'Περίπτερο',
			'Exhibitor': 'Εκθέτης',
			'Country Code': 'Κωδικός Χώρας',
			'Only latin and special characters allowed.': 'Επιτρέπονται μόνο λατινικοί και ειδικοί χαρακτήρες.',
			'Enter a valid email': 'Εισαγάγετε ένα έγκυρο email',
			'Save Visitor And Print Badge': 'Αποθήκευση Επισκέπτη και Εκτύπωση Badge',
			'quick_import_visitors_for_badge_printing': 'Στην παρούσα σελίδα μπορείτε να κάνετε γρήγορη προσθήκη <strong>ΕΠΙΣΚΕΠΤΩΝ</strong> και να εκτυπώσετε τα badges τους.<br/> Πατήστε στο κουμπί <strong>ΕΙΣΑΓΩΓΗ ΑΠΟ EXCEL</strong> για να εισάγετε πολλαπλούς επισκέπτες ή συμπληρώστε τη φόρμα για την προσθήκη ενός επισκέπτη και πατήστε στο κουμπί  <strong>ΑΠΟΘΗΚΕΥΣΗ ΕΠΙΣΚΕΠΤΗ ΚΑΙ ΕΚΤΥΠΩΣΗ BADGE</strong>.<br/><br/><strong>Προσοχή:</strong> Ακολουθείστε τις οδηγίες για την επιτυχή καταχώρηση επισκεπτών από excel. Παρακαλώ μην κλείσετε το παράθυρο μέχρι να ολοκληρωθεί η διαδικασία εκτύπωσης.<br/>',
			'Address 1 Country': 'Χώρα Διεύθυνσης 1',
			'Country': 'Χώρα',
			'Last Login': 'Τελευταία Σύνδεση',
			'Username': 'Όνομα Χρήστη',
			'Catalogue Example': 'Υπόδειγμα Καταλόγου',
			'Attention! Cursor must be placed inside the field to scan the barcode successfully...': 'ΠΡΟΣΟΧΗ: Ο κέρσορας πρέπει να είναι τοποθετημένος μέσα στο πεδίο για να πραγματοποιηθεί η σάρωση badge!',
			'Entry Cards (Badges)': 'Κάρτες Εισόδου (Badges)',
			'Entry Cards (Badges) - Exhibitors': 'Κάρτες Εισόδου (Badges) - Εκθέτες',
			'Entry Cards (Badges) - Service Providers': 'Κάρτες Εισόδου (Badges) - Service Providers',
			'Entry Cards (Badges) - Contractors': 'Κάρτες Εισόδου (Badges) - Κατασκευαστές',
			'Business Categories': 'Επαγγελματικές κατηγορίες',
			'Invitation': 'Αποστολή Πρόσκλησης',
			'Click this button to open a new browser tab and drag the window into another monitor': 'Κάντε κλικ σε αυτό το κουμπί για να ανοίξετε μια νέα καρτέλα του προγράμματος περιήγησης και σύρετε το παράθυρο σε μια άλλη οθόνη',
			'User data confirmation screen': 'Οθόνη επιβεβαίωσης δεδομένων χρήστη',
			'Code not valid. Visitor not found in current exhibition.': 'Κωδικός μη έγκυρος. Ο επισκέπτης δεν βρέθηκε σε αυτήν την έκθεση.',
			'Visitor badge already scanned.': 'Ο κωδικός έχει ήδη σαρωθεί.',
			'Visitor not approved for entry in current exhibition.': 'Ο επισκέπτης δεν έχει εγκριθεί.',
			'None': 'Κανένας',
			'Mobile Phone': 'Κινητό Τηλέφωνο',
			'Type': 'Τύπος',
			'more': 'ΑΤΟΜΑ',
			'required': 'Υποχρεωτικό πεδίο',
			'Required': 'Υποχρεωτικό πεδίο',
			partner_limit: "Μπορείτε να προσθέσετε <bold>έως και {{maximum}}</bold> άτομα. <bold>Απομένουν {{remainder}}</bold>",
			badge_info: "Στην παρούσα σελίδα μπορείτε να εκτυπώσετε τις κάρτες εισόδου για εσάς και το προσωπικό σας.<br/> Πατήστε στο κουμπί <strong>ΠΡΟΣΘΗΚΗ ΣΥΝΕΡΓΑΤΗ</strong> ή στο κουμπί <strong>ΕΙΣΑΓΩΓΗ ΑΠΟ EXCEL</strong>.<br /><br /><strong>Προσοχή</strong>: Για την απρόσκοπτη είσοδό σας στην έκθεση είναι απαραίτητο να έχετε μαζί σας την κάρτα εισόδου εκτυπωμένη. <br/><br/> Οι κάρτες εισόδου ισχύουν και ως κάρτες <strong>Parking</strong> στους χώρους στάθμευσης του εκθεσιακού κέντρου.",
			badge_info_service_provider: "Στην παρούσα σελίδα μπορείτε να εκτυπώσετε τις κάρτες εισόδου για εσάς και τους service providers σας.<br/> Πατήστε στο κουμπί <strong>ΠΡΟΣΘΗΚΗ SERVICE PROVIDER</strong> ή στο κουμπί <strong>ΕΙΣΑΓΩΓΗ ΑΠΟ EXCEL</strong>.<br /><br /><strong>Προσοχή</strong>: Για την απρόσκοπτη είσοδό σας στην έκθεση είναι απαραίτητο να έχετε μαζί σας την κάρτα εισόδου.",
			badge_info_contractor: "Στην παρούσα σελίδα μπορείτε να εκτυπώσετε τις κάρτες εισόδου για εσάς και τους κατασκευαστές σας.<br/> Πατήστε στο κουμπί <strong>ΠΡΟΣΘΗΚΗ ΚΑΤΑΣΚΕΥΑΣΤΗ</strong> ή στο κουμπί <strong>ΕΙΣΑΓΩΓΗ ΑΠΟ EXCEL</strong>.<br /><br /><strong>Προσοχή</strong>: Για την απρόσκοπτη είσοδό σας στην έκθεση είναι απαραίτητο να έχετε μαζί σας την κάρτα εισόδου.",
			'badge_info_exhibition_staff': 'Στην παρούσα σελίδα μπορείτε να εκτυπώσετε τις κάρτες εισόδου για το γενικό προσωπικό της έκθεσης.<br/> Πατήστε στο κουμπί <strong>ΠΡΟΣΘΗΚΗ ΠΡΟΣΩΠΙΚΟΥ ΕΚΘΕΣΗΣ</strong> ή στο κουμπί <strong>ΕΙΣΑΓΩΓΗ ΑΠΟ EXCEL</strong>.<br />',
			'badge_info_organizer': 'Στην παρούσα σελίδα μπορείτε να εκτυπώσετε τις κάρτες εισόδου για τους οργανωτές της έκθεσης.<br/> Πατήστε στο κουμπί <strong>ΠΡΟΣΘΗΚΗ ΟΡΓΑΝΩΤΗ</strong> ή στο κουμπί <strong>ΕΙΣΑΓΩΓΗ ΑΠΟ EXCEL</strong>.<br />',
			catalog_info: `Παρακαλούμε ελέγξτε και συμπληρώστε με προσοχή τα στοιχεία σας για τον κατάλογο της έκθεσης σύμφωνα με τις οδηγίες που εμφανίζονται παρακάτω. <br/><br/> Η "ΕΠΩΝΥΜΙΑ ΓΙΑ ΤΟΝ ΚΑΤΑΛΟΓΟ" που θα συμπληρώσετε είναι αυτό που θα εμφανίζεται στη λίστα εκθετών. <br/><br/> Ο κατάλογος θα είναι επεξεργάσιμος μέχρι <strong>{{date}}</strong>.`,
			invitation_info: "Από εδώ μπορείτε να στείλετε την πρόσκληση της έκθεσης μέσω email.<br/><br/> Πατήστε στο κουμπί <strong>ΠΡΟΣΘΗΚΗ ΕΠΙΣΚΕΠΤΗ</strong> ή στο κουμπί <strong>ΕΙΣΑΓΩΓΗ ΑΠΟ EXCEL</strong>.<br/>Μετά την προσθήκη ενός ή περισσότερων επισκεπτών, πατήστε το κουμπί <strong>ΑΠΟΣΤΟΛΗ ΠΡΟΣΚΛΗΣΕΩΝ (ΝΕΟΙ)</strong>, για να προσκαλέσετε μέσω email τους νέους επισκέπτες.<br/>Εναλλακτικά, επιλέξτε συγκεκριμένους επισκέπτες από τον πίνακα, και πατήστε το κουμπί <strong>ΑΠΟΣΤΟΛΗ ΠΡΟΣΚΛΗΣΗ ΣΕ ΕΠΙΣΚΕΠΤΕΣ</strong>, για να στείλετε πρόσκληση μέσω email στους επιλεγμένους μόνο επισκέπτες.<br /><br /><strong>Προσοχή</strong>: Η πρόσκληση αφορά αποκλειστικά εμπορικούς\n επισκέπτες.",
			'Send invitations': 'Αποστολή προσκλήσεων',
			'Actions': 'Ενέργειες',
			'This action is permanent. Press OK if you want to proceed.': 'Αυτή η ενέργεια είναι μόνιμη. Πατήστε OK εάν θέλετε να συνεχίσετε.',
			'Confirm Delete': 'Επιβεβαίωση Διαγραφής',
			'Remove': 'Αφαίρεση',
			// 'Send badge to {{count}} partners': 'Αποστολή badge σε {{count}} συνεργάτες',
			'Send badge to {{count}} partners': 'Αποστολή σε {{count}} επιλεγμένους',
			'Send badge to {{count}} exhibition staff': 'Αποστολή badge σε {{count}} προσωπικό έκθεσης',
			'Send badge to {{count}} organizers': 'Αποστολή badge σε {{count}} οργανωτές',
			'Send badge to {{count}} service providers': 'Αποστολή badge σε {{count}} service providers',
			'Send badge to {{count}} contractors': 'Αποστολή badge σε {{count}} κατασκευαστές',
			// 'Print badges of {{count}} partners': 'Εκτύπωση badges {{count}} συνεργατών',
			'Print badges of {{count}} partners': 'Εκτύπωση {{count}} επιλεγμένων',
			'Print badges of {{count}} service providers': 'Εκτύπωση badges {{count}} service providers',
			'Print badges of {{count}} contractors': 'Εκτύπωση badges {{count}} κατασκευαστών',
			'Print badges of {{count}} exhibition staff': 'Εκτύπωση badges {{count}} ατόμων προσωπικού έκθεσης.',
			'Print badges of {{count}} organizers': 'Εκτύπωση badges {{count}} οργανωτών.',
			'Exhibition Staff': 'Προσωπικό Έκθεσης',
			'Organizers': 'Οργανωτές',
			'You reached the limit of partners you can add.': 'Φτάσατε στο όριο συνεργατών που μπορείτε να προσθέσετε.',
			'You reached the limit of service providers you can add.': 'Φτάσατε στο όριο service providers που μπορείτε να προσθέσετε.',
			'You reached the limit of contractors you can add.': 'Φτάσατε στο όριο κατασκευαστών που μπορείτε να προσθέσετε.',
			'Delete {{count}} selected': 'Διαγραφή {{count}} επιλεγμένων',
			'Send to {{count}} visitors': 'Αποστολή σε {{count}} επιλεγμένους',
			'Send invitation to {{count}} exhibitors': 'Αποστολή προσκλήσεων σε {{count}} εκθέτες',
			'Send invitation to {{count}} visitors': 'Αποστολή σε {{count}} επιλεγμένους',
			'This list is visible to exhibitors/visitors when prompted to select their interests.': 'Αυτή η λίστα είναι ορατή στους εκθέτες/επισκέπτες όταν τους ζητηθεί να επιλέξουν τα ενδιαφέροντά τους.',
			'Send to new': 'Αποστολή στους νέους',
			'Send Invitation (All)': 'Αποστολή Προσκλήσεων (Όλες)',
			'Resend badges to visitors that previously received QR, but have not visited the exhibition yet.': 'Επαναποστολή badge σε επισκέπτες που έχουν λάβει QR, αλλά δεν έχουν επισκεφθεί ακόμα την έκθεση.',
			'Resend Badges': 'Επαναποστολή Badges',
			'Files': 'Αρχεία',
			'Upload any files necessary for your participation below.': 'Ανεβάστε όλα τα απαραίτητα αρχεία για τη συμμετοχή σας παρακάτω.',
			'FAQs': 'Συχνές Ερωτήσεις',
			// 'catalog_submit_disabled': 'Η επεξεργασία καταλόγου είναι απενεργοποιημένη για αυτήν την έκθεση.<br/>Μπορείτε να δείτε μόνο τις πληροφορίες του καταλόγου σας. Επικοινωνήστε μαζί μας στο <a href=\'mailto:{{email}}\'>{{email}}</a> εάν χρειάζεστε βοήθεια.',
			'catalog_submit_disabled': 'Η επεξεργασία καταλόγου είναι απενεργοποιημένη για αυτήν την έκθεση. Μπορείτε να δείτε μόνο τις πληροφορίες του καταλόγου σας. <br/> <strong>ΠΡΟΣΟΧΗ:</strong> Αλλαγές στα στοιχεία του καταλόγου δύναται να πραγματοποιηθούν μετά από επικοινωνία μαζί μας. <br/>Επικοινωνήστε μαζί μας στο <a href=\'mailto:{{email}}\'>{{email}}</a>, εάν χρειάζεστε βοήθεια.',
			'temp_message': 'Σας ενημερώνουμε ότι, λόγω τεχνικού προβλήματος, ο κατάλογος θα παραμείνει προσωρινά ανενεργός.<br/>Ευχαριστούμε για την κατανόηση.',
			'catalog_submit_ended_warning': 'Η περίοδος κατά την οποία μπορείτε να επεξεργαστείτε τις πληροφορίες του καταλόγου σας έχει λήξει.',
			'catalog_submit_warning': 'Μπορείτε να υποβάλετε τα στοιχεία του καταλόγου σας μέχρι και την <bold>{{date}}</bold>.',
			'alert_for_catalog_submission': '<em>Τελική Ημερομηνία Υποβολής Καταλόγου <strong>{{date}}</strong>!</em>',
			'Info': 'Σημείωση',
			'Warning': 'Προειδοποίηση',
			'DISABLED': 'ΑΠΕΝΕΡΓΟΠΟΙΗΜΕΝΟ',
			'Misc Information': 'Λοιπές Πληροφορίες',
			'WAITING': 'ΣΕ ΑΝΑΜΟΝΗ',
			'Waiting...': 'Σε αναμονή...',
			'SCANNING': 'ΣΑΡΩΣΗ',
			'Navigate to': 'Πλοηγηθείτε στην',
			'page, from a different tab': 'σελίδα, από διαφορετική καρτέλα',
			'- AND -': '- ΚΑΙ -',
			'Scan Badge': 'Σάρωση badge',
			'Use your device to scan a QR code.': 'Χρησιμοποιήστε την συσκευή σας για να σαρώσετε έναν κωδικό QR',
			'Scan another badge': 'Σάρωση άλλου badge',
			'Save': 'Αποθήκευση',
			'Interests': 'Επαγγελματική Ιδιότητα',
			'Countries': 'Χώρα',
			'Corridor/Number': 'Διάδρομος/Αριθμός',
			'Code': 'Κωδικός',
			'Exhibition Details': 'Λεπτομέρειες Έκθεσης',
			'Profile': 'Προφίλ',
			'Stand Number': 'Αριθμός Περιπτέρου',
			'Kiosk Sign': 'Μετόπη',
			'Hall': 'Αίθουσα',
			'Address Category': 'Κατηγορία Διεύθυνσης',
			'Phone': 'Τηλέφωνο',
			'Invited By': 'Προσκλήθηκε Από',
			'Last Modified Date': 'Ημερομηνία Τελευταίας Επεξεργασίας',
			'Invitation Date': 'Ημερομηνία Πρόσκλησης',
			'Preregistration Date': 'Ημερομηνία Προεγγραφής',
			'Add a partner': 'Προσθήκη συνεργάτη',
			'Add a service provider': 'Προσθήκη service provider',
			'Add a contractor': 'Προσθήκη κατασκευαστή',
			'Add exhibition staff': 'Προσθήκη προσωπικού έκθεσης',
			'Add organizer': 'Προσθήκη οργανωτή',
			'Add a visitor': 'Προσθήκη επισκέπτη',
			'Add new visitor': 'Προσθήκη νέου επισκέπτη',
			'Search visitor': 'Εύρεση επισκέπτη',
			'Switch Camera': 'Εναλλαγή κάμερας',
			'Import from excel': 'Εισαγωγή από excel',
			'import_excel_msg': 'Εάν θέλετε να προσθέσετε περισσότερα από ένα άτομα γρήγορα, μπορείτε να ανεβάσετε ένα αρχείο <strong>Excel</strong>.<br/><ul><li>Το αρχείο excel πρέπει να ακολουθεί τη δομή που περιγράφεται παρακάτω.</li><li>Βεβαιωθείτε ότι οι στήλες σας είναι σε σειρά όπως στον πίνακα του παραδείγματος.</li><li>Για τη διευκόλυνσή σας, μπορείτε επίσης να κάνετε λήψη του κενού προτύπου excel.</li></ul>',
			'Mail': 'E-mail',
			'Name (EL)': 'Ονοματεπώνυμο (EL)',
			'Name (EN)': 'Ονοματεπώνυμο (EN)',
			'Name': 'Ονοματεπώνυμο',
			'Company Name': 'Επωνυμία Εταιρείας / Οργανισμός',
			'Status': 'Κατάσταση',
			'optional': 'προαιρετικό',
			'Download excel template': 'Κατέβασμα προτύπου excel',
			'Import selected file': 'Εισαγωγή επιλεγμένου αρχείου',
			'Characterization': 'Χαρακτηρισμός',
			'Cancel': 'Ακύρωση',
			'Partners': 'Συνεργάτες',
			'Contractors': 'Κατασκευαστές',
			'Visitors': 'Επισκέπτες',
			'Catalogue': 'Κατάλογος Έκθεσης',
			'Profile Information': 'Πληροφορίες Προφίλ',
			'EXPORT CATALOG DATA': 'ΕΞΑΓΩΓΗ ΣΤΟΙΧΕΙΩΝ ΚΑΤΑΛΟΓΟΥ',
			'EXPORT CATALOG DATA IN WORD': 'ΕΞΑΓΩΓΗ ΣΤΟΙΧΕΙΩΝ ΚΑΤΑΛΟΓΟΥ ΣΕ WORD',
			'EXPORT CATALOG DATA IN EXCEL': 'ΕΞΑΓΩΓΗ ΣΤΟΙΧΕΙΩΝ ΚΑΤΑΛΟΓΟΥ ΣΕ EXCEL',
			'Type contact information of the person you want to add as a visitor for this event.': 'Πληκτρολογήστε τα στοιχεία επικοινωνίας του ατόμου που θέλετε να προσθέσετε ως επισκέπτη για αυτήν την εκδήλωση.',
			'Type contact information of the person you want to add as a partner for this event.': 'Πληκτρολογήστε τα στοιχεία επικοινωνίας του ατόμου που θέλετε να προσθέσετε ως συνεργάτη για αυτήν την εκδήλωση.',
			'Type contact information of the person you want to add as a service provider for this event.': 'Πληκτρολογήστε τα στοιχεία επικοινωνίας του ατόμου που θέλετε να προσθέσετε ως service provider για αυτήν την εκδήλωση.',
			'Type contact information of the person you want to add as a contractor for this event.': 'Πληκτρολογήστε τα στοιχεία επικοινωνίας του ατόμου που θέλετε να προσθέσετε ως κατασκευαστή για αυτήν την εκδήλωση.',
			'Type contact information of the person you want to add as exhibition staff for this event.': 'Πληκτρολογήστε τα στοιχεία επικοινωνίας του ατόμου που θέλετε να προσθέσετε ως προσωπικό έκθεσης για αυτήν την εκδήλωση.',
			'Type contact information of the person you want to add as organizer for this event.': 'Πληκτρολογήστε τα στοιχεία επικοινωνίας του ατόμου που θέλετε να προσθέσετε ως οργανωτή για αυτήν την εκδήλωση.',
			'{{count}} emails will be sent in the next hours': '{{count}} emails θα σταλούν μέσα στις επόμενες ώρες',
			'emailCatalogue': 'Email Καταλόγου',
			'catalogueProfileLength': 'Επιτρεπόμενος Αριθμός Χαρακτήρων Καταλόγου',
			'Visitor Approved': 'Εγκεκριμένος Επισκέπτης',
			"Printing... Please don't close the browser before the process ends.": "Πραγματοποιείται εκτύπωση... Παρακαλώ μην κλείσετε την οθόνη του browser πριν τελειώσει η διαδικασία.",
			
			"COMPANY NAME": "ΕΠΩΝΥΜΙΑ ΕΤΑΙΡΕΙΑΣ",
			" (IN CAPITAL LATIN LETTERS)": " (ΜΕ ΚΕΦΑΛΑΙΟΥΣ ΛΑΤΙΝΙΚΟΥΣ ΧΑΡΑΚΤΗΡΕΣ",
			"Address": "Διεύθυνση",
			"Tel.": "Τηλ.",
			"Website": "Ιστοσελίδα",
			"COMPANY PROFILE (Up to 800 characters in lowercase letters)": "ΠΕΡΙΓΡΑΦΗ ΑΝΤΙΚΕΙΜΕΝΟΥ (",
			"COMPANY PROFILE": "ΠΕΡΙΓΡΑΦΗ ΑΝΤΙΚΕΙΜΕΝΟΥ",
			"catalog_example": "<br/>Οργάνωση εκθέσεων, οργάνωση συνεδρίων, εκδηλώσεις",
			'rota_address': '4, Λεωφ. Ανθούσας, 15351 Παλλήνη - Ατιική',
			'COMPANY PROFILE (Up to 350 characters)': 'ΠΕΡΙΓΡΑΦΗ ΑΝΤΙΚΕΙΜΕΝΟΥ (εώς 350 λέξεις)',
			"Select export language.": "Επιλέξετε τη γλώσσα της εξαγωγής.",
			"Greek": "Ελληνικά",
			"English": "Αγγλικά",
			"confirmedCatalogue": "Αποθήκευση Καταλόγου",
			"Transfer Data From Entersoft": "Μεταφορά Δεδομένων από Entersoft",
			
			"Final Confirmation of Catalogue Data": "Τελική Επιβεβαίωση Στοιχείων Καταλόγου",
			"Cancel Catalogue Data Confirmation": "Αναίρεση Επιβεβαίωσης Στοιχείων Καταλόγου",
			"Catalogue Entry Instructions": "Οδηγίες Συμπλήρωσης Καταλόγου",
			"Instructions": "Οδηγίες",
			"Both Confirmed and Unconfirmed Catalogues": "Επιβεβαιωμένοι και Μη Επιβεβαιωμένοι Κατάλογοι",
			"Confirmed Catalogues Only": "Μόνο Επιβεβαιωμένοι Κατάλογοι",
			"Unconfirmed Catalogues Only": "Μόνο Μη Επιβεβαιωμένοι Κατάλογοι",
			'Export Visitors': 'Εξαγωγή Επισκεπτών',
			'Transfer Catalogues To EnterSoft': 'Μεταφορά Καταλόγων Στο EnterSoft',
			'Transfer Confirmation': 'Επιβεβαίωση Μεταφοράς',
			'transfer_confirmation': "<br/><strong>ΠΡΟΣΟΧΗ</strong>: Η ΔΙΑΔΙΚΑΣΙΑ ΑΥΤΗ ΕΙΝΑΙ ΜΗ ΑΝΑΣΤΡΕΨΙΜΗ. <br/><br/> ΟΙ ΚΑΤΑΛΟΓΟΙ ΤΗΣ ΕΚΘΕΣΗΣ ΘΑ ΜΕΤΑΦΕΡΘΟΥΝ ΑΠΟ ΤΟ ΠΟΡΤΑΛ ΣΤΗ ΒΑΣΗ ΤΟΥ ENTERSOFT. <br/><br/><strong>ΔΕΝ ΜΠΟΡΕΙΤΕ ΝΑ ΑΝΑΙΡΕΣΕΤΕ ΑΥΤΗΝ ΤΗ ΔΙΑΔΙΚΑΣΙΑ.</strong><br/> ΘΕΛΕΤΕ ΝΑ ΣΥΝΕΧΙΣΕΤΕ;",
			'Confirm And Start Transfer EnterSoft': 'ΕΠΙΒΕΒΑΙΩΣΗ ΚΑΙ ΕΚΚΙΝΗΣΗ ΜΕΤΑΦΟΡΑΣ ΣΤΟ ENTERSOFT',
			'Edit': 'Επεξεργασία',
			'Exhibitors': 'ΕΚΘΕΤΕΣ',
			'Confirm Sent': 'Επιβεβαίωση Αποστολής',
			'Confirm Catalogue Submission': 'Επιβεβαίωση Υποβολής Καταλόγου',
			'Catalogue Preview': 'Προεπισκόπηση Καταλόγου',
			'Greek Preview': 'Ελληνική Προεπισκόπηση',
			'English Preview': 'Αγγλική Προεπισκόπηση',
			'You may have empty optional fields in your catalogue.': 'Δεν έχετε συμπληρώσει τα προαιρετικά πεδία στον κατάλογό σας.',
			'Do you still wish to submit your catalogue?': 'Θέλετε να προχωρήσετε στην αποθήκευση;',
			'YES': 'ΝΑΙ',
			'NO': 'ΟΧΙ',
			"Kiosk Sign Not Editable": "Απενεργοποίηση Επεξεργασίας Μετόπης",
			"Kiosk Sign Editable": "Επεξεργάσιμη Μετόπη",
			'Disabled Kiosk Sign Edit': 'Απενεργοποιημένη επεξεργασία μετόπης',
			'Transfer {{count}} Catalogues to EnterSoft': 'Μεταφορά {{count}} Καταλόγων Στο EnterSoft',
			'Number of Invites': 'Αριθμός Προσκλήσεων',
			'Advertisement Logo': 'Logo Διαφήμισης',
			'Send': 'Αποστολή',
			'Send Invitation To Different Email': 'Αποστολή Πρόσκλησης Σε Διαφορετικό Email',
			'CompanyName': 'Επωνυμία Εταιρείας / Οργανισμός',
			'VatRegNo': 'Α.Φ.Μ.',
			'Position': 'Θέση / Τμήμα',
			'Email': 'E-mail',
			'CompanyMobilePhone': 'Κινητό Τηλέφωνο',
			'CompanyAddress': 'Διεύθυνση Εταιρείας',
			'CompanyCity': 'Πόλη',
			'CompanyPostalCode': 'Ταχυδρομικός Κώδικας',
			'CompanyBusinessPhone': 'Τηλέφωνο',
			'CompanyWebSite': 'Ηλεκτρονική Σελίδα Εταιρείας',
			'Visitor Details': 'Στοιχεία Επισκέπτη',
			'Submit Comment': 'Υποβολή Σχολίου',
			'Comments': 'Σχόλια',
			'camera_scan': '<strong>Σάρωση με Κάμερα:</strong> Για να πραγματοποιηθεί σάρωση με κάμερα, δε χρειάζεται ο κέρσορας να είναι τοποθετημένος μέσα στο πεδίο. <br/> Μετά από μία σάρωση, παραμένει στο πεδίο ο αριθμός του badge και αντικαθίσταται με καινούργιο στην επόμενη σάρωση από κάμερα.',
			'double_scan': '<strong>Προσοχή:</strong> Σε περίπτωση που θέλουμε να ξανά σαρώσουμε δύο φορές συνεχόμενα το ίδιο badge, πρέπει να πατήσουμε <strong>Καθαρισμός</strong>. <br/>Η συνεχόμενη σάρωση του ίδιου badge δε γίνεται αυτομάτως, για να μην πραγματοποιούνται πολλαπλές κλήσεις, όταν το κρατάμε μπροστά από την κάμερα.',
			'clear_scan': '<strong>Καθαρισμός:</strong> Πατώντας Καθαρισμός, καθαρίζουμε το πεδίο και το μήνυμα της τελευταίας σάρωσης.',
			'write_badge_code': '<strong>Γράψιμο αριθμού Badge σε πεδίο:</strong> Εάν έχουμε τον αριθμό ενός badge, μπορούμε να τον κάνουμε <strong>Copy Paste</strong> ή να τον γράψουμε στο πεδίο για να πραγματοποιηθεί έλεγχος της εγκυρότητάς του. <br/>Ο έλεγχος γίνεται απευθείας και το πεδίο καθαρίζει.',
			'scanner_scan': '<strong>Σάρωση με Scanner:</strong> Για να πραγματοποιηθεί σάρωση με scanner, πρέπει ο κέρσορας να είναι τοποθετημένος μέσα στο πεδίο. Μετά από μία σάρωση, το πεδίο καθαρίζει αυτομάτως για να πραγματοποιηθεί η επόμενη.',
			'You can print maximum of 200 partner badges at once!': 'Μπορείτε να εκτυπώσετε το πολύ 200 badge συνεργατών ταυτόχρονα!'
		},
		en: {
			'info_catalogue_company_profile': 'Maximum length: {{length}} characters.',
			'info_catalogue_company_name': 'The ‘‘COMPANY NAME FOR THE CATALOGUE’’ will appear wherever exhibitors are mentioned eg. exhibitor list.',
			'camera_scan': '<strong>Camera Scan:</strong> To perform a scan with the camera, the cursor does not need to be placed inside the field. <br/> After a scan, the badge number remains in the field and is replaced with a new one on the next camera scan.',
			'double_scan': '<strong>Attention:</strong> If we want to scan the same badge twice in a row, we need to press <strong>Clear</strong> first. Continuous scanning of the same badge does not happen automatically, to prevent multiple calls when the badge is held in front of the camera.',
			'clear_scan': '<strong>Clear:</strong> By pressing Clear, we clear both the field and the message from the last scan.',
			'write_badge_code': '<strong>Entering Badge Number in Field:</strong> If we have the number of a badge, we can either <strong>Copy and Paste</strong> it or type it into the field to validate its authenticity. <br/>The validation happens immediately, and the field is cleared.',
			'scanner_scan': '<strong>Scanner:</strong> To perform a scan with a scanner, the cursor must be placed inside the field. After a scan, the field is automatically cleared to allow for the next one.',
			'Name': 'Name / Surname',
			'CompanyName': 'Company Name / Organization',
			'VatRegNo': 'Vat Registration No',
			'Position': 'Position / Department',
			'Email': 'E-mail',
			'CompanyMobilePhone': 'Mobile Phone',
			'Country': 'Country',
			'CompanyAddress': 'Company Address',
			'CompanyCity': 'City',
			'CompanyPostalCode': 'Postal Code',
			'CompanyBusinessPhone': 'Phone',
			'CompanyWebSite': 'Company WebSite',
			'catalogue_company_name': 'COMPANY NAME',
			'catalogue_company_profile': 'COMPANY PROFILE',
			'catalogue_address': 'ADDRESS',
			'catalogue_city': 'CITY',
			'catalogue_country': 'COUNTRY',
			'catalogue_postal': 'ZIP CODE',
			'catalogue_phone_code': 'COUNTRY PHONE CODE',
			'catalogue_phone': 'TEL',
			'VAT Number': 'Tax Registration Number',
			'Kiosk': 'Stand',
			'Kiosk Sign': 'Stand Sign',
			'Required': 'Υποχρεωτικό πεδίο',
			required: 'Required',
			'emailCatalogue': 'Catalogue Email',
			'catalogueProfileLength': 'Catalogue Maximum Characters Allowed',
			'Company Name': 'Company Name / Organization',
			'Select export filters and press EXPORT.': 'Select export filters and press EXPORT.',
			"catalog_example": "<br/>Organizing exhibitions, organizing conferences, events",
			'rota_address': '4, Anthousas Ave., 15351 Pallini - Attica',
			"confirmedCatalogue": "Catalogue Saved",
			'Exhibitors': 'EXHIBITORS',
			'This is an info text' : 'Αυτό είναι ένα κείμενο πληροφορίας'
		},
	},
	[Namespaces.TABLE_COMPONENT]: {
		el: {
			Show: "Εμφάνιση",
			Showing: "Εμφάνιση",
			results: 'αποτελέσματα',
			Loading: "Φόρτωση",
			'per page': "ανα σελίδα",
			'Go to page': 'Πήγαινε στην σελίδα',
			'Page': 'Σελίδα',
			'of': 'από',
			'no_results': 'Δεν υπάρχουν ενεργές εκθέσεις!',
		},
		en: {
			'no_results': 'No active exhibitions found!',
		}
	},
	[Namespaces.DELETE_CONFIRMATION]: {
		el: {
			delete: 'ΔΙΑΓΡΑΦΗ',
			cancel: 'ΑΚΥΡΟ',
		},
		en: {
			delete: 'DELETE',
			cancel: 'CANCEL',
		},
	},
	[Namespaces.SEARCH_COMPONENT]: {
		el: {
			search: "Αναζήτηση Κωδικού Προϊόντος",
			search_local: "Αναζήτηση προϊόντων στη {{orderType}}",
			results_1: 'ΑΠΟΤΕΛΕΣΜΑΤΑ',
			results_2: 'ΑΝΑΖΗΤΗΣΗΣ',
			results: 'ΑΠΟΤΕΛΕΣΜΑΤΑ',
		},
		en: {
			search: "Search Product Code",
			search_local: "Search products in {{orderType}}",
			results_1: 'SEARCH',
			results_2: 'RESULTS',
			results: 'RESULTS',
		}
	},
	[Namespaces.DYNAMIC_LIST_AS_TABLE_COMPONENT]: {
		el: {
			Add: 'Προσθήκη',
			Field: 'Πεδίο',
			Operator: 'Τελεστής',
			'ErpCode': 'Κωδικός ERP',
			'ContactId': 'ID Επαφής',
			'Name': 'Ονοματεπώνυμο',
			'email': 'E-mail',
			'BussinessPhone': 'Τηλέφωνο',
			'MobilePhone': 'Κινητό Τηλέφωνο',
			'CompanyName': 'Επωνυμία Εταιρείας / Οργανισμός',
			'CompanyWebSite': 'Ηλεκτρονική Σελίδα Εταιρείας',
			'CompanyAddress': 'Διεύθυνση Εταιρείας',
			'PostalCode': 'Ταχυδρομικός Κώδικας',
			'City': 'Πόλη',
			'CountryId': 'Χώρα',
			'PersonCount': 'Αριθμός Ατόμων',
			'VatRegNo': 'Α.Φ.Μ.',
			'isIndividual': 'Ιδιώτης',
			'hasRevisited': 'Έχει Ξανά Επισκεφτεί',
			'Interests': 'Επαγγελματική Ιδιότητα',
			'FromRegistration': 'Εγγραφή από Registration',
			'FromPreregistration': 'Εγγραφή από Preregistration',
			'FromImport': 'Είσοδος από Import',
			'hasInterests': 'Έχει Επαγγελματική Ιδιότητα',
			'OtherInterests': 'Άλλη Επαγγελματική Ιδιότητα',
			'Position': 'Θέση / Τμήμα',
			'FromImportNum': 'Από αριθμό Import',
			'Facebook': 'Facebook',
			'Instagram': 'Instagram',
		},
		en: {
			'ErpCode': 'ERP Code',
			'ContactId': 'Contact ID',
			'Name': 'Name / Surname',
			'email': 'E-mail',
			'BussinessPhone': 'Phone',
			'MobilePhone': 'Mobile Phone',
			'CompanyName': 'Company Name / Organization',
			'CompanyWebSite': 'Company Website',
			'CompanyAddress': 'Company Address',
			'PostalCode': 'Postal Code',
			'City': 'City',
			'CountryId': 'Country',
			'PersonCount': 'Person Count',
			'VatRegNo': 'Vat Registration No',
			'isIndividual': 'Individual',
			'hasRevisited': 'Has Revisited',
			'Interests': 'Profession Domain',
			'FromRegistration': 'From Registration',
			'FromPreregistration': 'From Preregistration',
			'FromImport': 'From Import',
			'hasInterests': 'Has Profession Domain',
			'OtherInterests': 'Other Profession Domain',
			'Position': 'Position / Department',
			'FromImportNum': 'From Import Num'
		}
	},
	[Namespaces.RULES]: {
		el: {
			Add: 'Προσθήκη',
			'Rule Conditions': 'Συνθήκες Κανόνων',
			'Open Rule Conditions': 'Άνοιγμα Συνθηκών Κανόνων',
			'Description': 'Περιγραφή',
			'Characterization': 'Κατηγορία Επισκέπτη',
			'Add Rule Conditions': 'Προσθήκη Συνθήκης Κανόνα',
			'Deleting rule details failed.': 'Αποτυχία διαγραφής συνθήκης κανόνα.',
			'Deleting rule details succeeded.': 'Επιτυχία διαγραφής συνθήκης κανόνα.',
			'Updating rule details failed.': 'Αποτυχία ενημέρωσης συνθήκης κανόνα.',
			'Updating rule details succeeded.': 'Επιτυχία ενημέρωσης συνθήκης κανόνα.',
			'Storing rule details failed.': 'Αποτυχία προσθήκης συνθήκης κανόνα.',
			'Storing rule details succeeded.': 'Επιτυχία προσθήκης συνθήκης κανόνα.',
			'Getting rule details failed.': 'Αποτυχία φόρτωσης συνθηκών κανόνα.',
			'Deleting rule failed.': 'Αποτυχία διαγραφής κανόνα.',
			'Deleting rule succeeded.': 'Επιτυχία διαγραφής κανόνα.',
			'Updating rule failed.': 'Αποτυχία ενημέρωσης κανόνα.',
			'Updating rule succeeded.': 'Επιτυχία ενημέρωσης κανόνα.',
			'Storing rule failed.': 'Αποτυχία αποθήκευσης κανόνα.',
			'Saving rule succeeded.': 'Επιτυχία αποθήκευσης κανόνα.',
			'Fetching rules failed.': 'Αποτυχία φόρτωσης κανόνων.',
		},
		en: {
			'Characterization': 'Visitor Category',
		}
	},
	[Namespaces.EDITABLE_MUI_GRID]: {
		el: {
			'Add': 'Προσθήκη',
			'Actions': 'Ενέργειες',
			'Press Yes to confirm entry deletion.': 'Πατήστε ΝΑΙ για να επιβεβαιώσετε τη διαγραφή της εγγραφής.',
			'Delete Entry Confirmation.': 'Επιβεβαίωση Διαγραφής.',
			'no': 'Όχι',
			'yes': 'Ναι',
			noRowsLabel: 'Δεν υπάρχουν καταχωρήσεις',
			noResultsOverlayLabel: 'Δεν βρέθηκαν αποτελέσματα.',
			toolbarDensity: 'Ύψος σειράς',
			toolbarDensityLabel: 'Ύψος σειράς',
			toolbarDensityCompact: 'Συμπαγής',
			toolbarDensityStandard: 'Προκαθορισμένο',
			toolbarDensityComfortable: 'Πλατύ',
			toolbarColumns: 'Στήλες',
			toolbarColumnsLabel: 'Επιλέξτε στήλες',
			toolbarFilters: 'Φίλτρα',
			toolbarFiltersLabel: 'Εμφάνιση φίλτρων',
			toolbarFiltersTooltipHide: 'Απόκρυψη φίλτρων',
			toolbarFiltersTooltipShow: 'Εμφάνιση φίλτρων',
			toolbarFiltersTooltipActive: (count) =>
				count !== 1 ? `${count} ενεργά φίλτρα` : `${count} ενεργό φίλτρο`,
			toolbarQuickFilterPlaceholder: 'Αναζήτηση...',
			toolbarQuickFilterLabel: 'Αναζήτηση',
			toolbarQuickFilterDeleteIconLabel: 'Καθαρισμός',
			toolbarExport: 'Εξαγωγή',
			toolbarExportLabel: 'Εξαγωγή',
			toolbarExportCSV: 'Λήψη ως CSV',
			toolbarExportPrint: 'Εκτύπωση',
			toolbarExportExcel: 'Κατέβασμα ως Excel',
			columnsPanelTextFieldLabel: 'Εύρεση στήλης',
			columnsPanelTextFieldPlaceholder: 'Επικεφαλίδα στήλης',
			columnsPanelDragIconLabel: 'Αναδιάταξη στήλης',
			columnsPanelShowAllButton: 'Προβολή όλων',
			columnsPanelHideAllButton: 'Απόκρυψη όλων',
			filterPanelAddFilter: 'Προσθήκη φίλτρου',
			filterPanelRemoveAll: 'Αφαίρεση όλων',
			filterPanelDeleteIconLabel: 'Διαγραφή',
			filterPanelLogicOperator: 'Λογικός τελεστής',
			filterPanelOperator: 'Τελεστές',
			filterPanelOperatorAnd: 'και',
			filterPanelOperatorOr: 'ή',
			filterPanelColumns: 'Στήλες',
			filterPanelInputLabel: 'Τιμή',
			filterPanelInputPlaceholder: 'Τιμή φίλτρου',
			filterOperatorContains: 'περιέχει',
			filterOperatorEquals: 'ισούται',
			filterOperatorStartsWith: 'ξεκινάει με',
			filterOperatorEndsWith: 'τελειώνει με',
			filterOperatorIs: 'είναι',
			filterOperatorNot: 'δεν είναι',
			filterOperatorAfter: 'είναι μετά',
			filterOperatorOnOrAfter: 'είναι ίσο ή μετά',
			filterOperatorBefore: 'είναι πριν',
			filterOperatorOnOrBefore: 'είναι ίσο ή πριν',
			filterOperatorIsEmpty: 'είναι κενό',
			filterOperatorIsNotEmpty: 'δεν είναι κενό',
			filterOperatorIsAnyOf: 'είναι οποιοδήποτε από',
			filterValueAny: 'οποιοδήποτε',
			filterValueTrue: 'αληθής',
			filterValueFalse: 'ψευδής',
			columnMenuLabel: 'Μενού',
			columnMenuShowColumns: 'Εμφάνιση στηλών',
			columnMenuManageColumns: 'Διαχείριση στηλών',
			columnMenuFilter: 'Φίλτρο',
			columnMenuHideColumn: 'Απόκρυψη',
			columnMenuUnsort: 'Απενεργοποίηση ταξινόμησης',
			columnMenuSortAsc: 'Ταξινόμηση σε αύξουσα σειρά',
			columnMenuSortDesc: 'Ταξινόμηση σε φθίνουσα σειρά',
			columnHeaderFiltersTooltipActive: (count) =>
				count !== 1 ? `${count} ενεργά φίλτρα` : `${count} ενεργό φίλτρο`,
			columnHeaderFiltersLabel: 'Εμφάνιση φίλτρων',
			columnHeaderSortIconLabel: 'Ταξινόμηση',
			footerRowSelected: (count) =>
				count !== 1
					? `${count.toLocaleString()} επιλεγμένες γραμμές`
					: `${count.toLocaleString()} επιλεγμένη γραμμή`,
			footerTotalRows: 'Σύνολο Γραμμών:',
			footerTotalVisibleRows: (visibleCount, totalCount) =>
				`${visibleCount.toLocaleString()} από ${totalCount.toLocaleString()}`,
			checkboxSelectionHeaderName: 'Επιλογή πλαισίου ελέγχου',
			checkboxSelectionSelectAllRows: 'Επιλέξτε όλες τις σειρές',
			checkboxSelectionUnselectAllRows: 'Καταργήστε την επιλογή όλων των σειρών',
			checkboxSelectionSelectRow: 'Επιλέξτε σειρά',
			checkboxSelectionUnselectRow: 'Καταργήστε την επιλογή σειράς',
			booleanCellTrueLabel: 'Ναι',
			booleanCellFalseLabel: 'Όχι',
			actionsCellMore: 'περισσότερα',
			pinToLeft: 'Καρφιτσώστε αριστερά',
			pinToRight: 'Καρφιτσώστε δεξιά',
			unpin: 'Ξεκαρφίτσωμα',
			treeDataGroupingHeaderName: 'Ομαδοποίησης Δεδομένων ',
			treeDataExpand: 'Ανάπτυξη',
			treeDataCollapse: 'Σύμπτυξη ',
			groupingColumnHeaderName: 'Ομαδοποίησης στηλών',
			groupColumn: name => `Ομαδοποίηση κατά ${name}`,
			unGroupColumn: name => `Διακοπή ομαδοποίησης κατά ${name}`,
			detailPanelToggle: 'Εναλλαγή πίνακα λεπτομερειών',
			expandDetailPanel: 'Ανάπτυξη',
			collapseDetailPanel: 'Σύμπτυξη',
			rowReorderingHeaderName: 'Αναδιάταξη σειρών',
			aggregationMenuItemHeader: 'Συσσωμάτωση',
			aggregationFunctionLabelSum: 'άθροισμα',
			aggregationFunctionLabelAvg: 'μέσος όρος',
			aggregationFunctionLabelMin: 'ελάχ.',
			aggregationFunctionLabelMax: 'μέγ.',
			aggregationFunctionLabelSize: 'μέγεθος',
		},
		en: {
			'no': 'No',
			'yes': 'Yes',
			noRowsLabel: 'No entries found',
			noResultsOverlayLabel: 'No results found.',
			toolbarDensity: 'Row height',
			toolbarDensityLabel: 'Row height',
			toolbarDensityCompact: 'Compact',
			toolbarDensityStandard: 'Standard',
			toolbarDensityComfortable: 'Comfortable',
			toolbarColumns: 'Columns',
			toolbarColumnsLabel: 'Select columns',
			toolbarFilters: 'Filters',
			toolbarFiltersLabel: 'Show filters',
			toolbarFiltersTooltipHide: 'Hide filters',
			toolbarFiltersTooltipShow: 'Show filters',
			toolbarFiltersTooltipActive: (count) =>
				count !== 1 ? `${count} active filters` : `${count} active filter`,
			toolbarQuickFilterPlaceholder: 'Search...',
			toolbarQuickFilterLabel: 'Search',
			toolbarQuickFilterDeleteIconLabel: 'Clear',
			toolbarExport: 'Export',
			toolbarExportLabel: 'Export',
			toolbarExportCSV: 'Download as CSV',
			toolbarExportPrint: 'Print',
			toolbarExportExcel: 'Download as Excel',
			columnsPanelTextFieldLabel: 'Find column',
			columnsPanelTextFieldPlaceholder: 'Column header',
			columnsPanelDragIconLabel: 'Reorder column',
			columnsPanelShowAllButton: 'Show all',
			columnsPanelHideAllButton: 'Hide all',
			filterPanelAddFilter: 'Add filter',
			filterPanelRemoveAll: 'Remove all',
			filterPanelDeleteIconLabel: 'Delete',
			filterPanelLogicOperator: 'Logic operator',
			filterPanelOperator: 'Operators',
			filterPanelOperatorAnd: 'and',
			filterPanelOperatorOr: 'or',
			filterPanelColumns: 'Columns',
			filterPanelInputLabel: 'Value',
			filterPanelInputPlaceholder: 'Filter value',
			filterOperatorContains: 'contains',
			filterOperatorEquals: 'equals',
			filterOperatorStartsWith: 'starts with',
			filterOperatorEndsWith: 'ends with',
			filterOperatorIs: 'is',
			filterOperatorNot: 'is not',
			filterOperatorAfter: 'is after',
			filterOperatorOnOrAfter: 'is on or after',
			filterOperatorBefore: 'is before',
			filterOperatorOnOrBefore: 'is on or before',
			filterOperatorIsEmpty: 'is empty',
			filterOperatorIsNotEmpty: 'is not empty',
			filterOperatorIsAnyOf: 'is any of',
			filterValueAny: 'any',
			filterValueTrue: 'true',
			filterValueFalse: 'false',
			columnMenuLabel: 'Menu',
			columnMenuShowColumns: 'Show columns',
			columnMenuManageColumns: 'Manage columns',
			columnMenuFilter: 'Filter',
			columnMenuHideColumn: 'Hide',
			columnMenuUnsort: 'Disable sorting',
			columnMenuSortAsc: 'Sort ascending',
			columnMenuSortDesc: 'Sort descending',
			columnHeaderFiltersTooltipActive: (count) =>
				count !== 1 ? `${count} active filters` : `${count} active filter`,
			columnHeaderFiltersLabel: 'Show filters',
			columnHeaderSortIconLabel: 'Sort',
			footerRowSelected: (count) =>
				count !== 1
					? `${count.toLocaleString()} selected rows`
					: `${count.toLocaleString()} selected row`,
			footerTotalRows: 'Total Rows:',
			footerTotalVisibleRows: (visibleCount, totalCount) =>
				`${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,
			checkboxSelectionHeaderName: 'Checkbox selection',
			checkboxSelectionSelectAllRows: 'Select all rows',
			checkboxSelectionUnselectAllRows: 'Unselect all rows',
			checkboxSelectionSelectRow: 'Select row',
			checkboxSelectionUnselectRow: 'Unselect row',
			booleanCellTrueLabel: 'Yes',
			booleanCellFalseLabel: 'No',
			actionsCellMore: 'more',
			pinToLeft: 'Pin to left',
			pinToRight: 'Pin to right',
			unpin: 'Unpin',
			treeDataGroupingHeaderName: 'Data Grouping',
			treeDataExpand: 'Expand',
			treeDataCollapse: 'Collapse',
			groupingColumnHeaderName: 'Grouping Columns',
			groupColumn: (name) => `Group by ${name}`,
			unGroupColumn: (name) => `Stop grouping by ${name}`,
			detailPanelToggle: 'Detail panel toggle',
			expandDetailPanel: 'Expand',
			collapseDetailPanel: 'Collapse',
			rowReorderingHeaderName: 'Row Reordering',
			aggregationMenuItemHeader: 'Aggregation',
			aggregationFunctionLabelSum: 'Sum',
			aggregationFunctionLabelAvg: 'Avg',
			aggregationFunctionLabelMin: 'Min',
			aggregationFunctionLabelMax: 'Max',
			aggregationFunctionLabelSize: 'Size',
		},
	},
	[Namespaces.AXIOS_ERROR_MESSAGE]: {
		el: {
			'Downloading...': 'Πραγματοποιείται λήψη...',
			'More': 'Περισσότερα..',
			'Less': 'Λιγότερα',
			'Unauthorized': 'Ο χρήστης δεν έχει πρόσβαση στην ιστοσελίδα.',
			'Failed to get notifications.': 'Αδυναμία φόρτωσης ειδοποιήσεων.',
			'Duplicate Entry': 'Υπάρχει ήδη αυτή η εγγραφή',
			'Not Found': 'Δεν βρέθηκε',
			errorMessage: 'Μήνυμα',
			'Message': 'Μήνυμα',
			moreMessage: '',
			'Code': 'Κωδικός',
			'Status': 'Status',
			'No data found or an error occurred!': 'Δεν βρέθηκαν δεδομένα ή προέκυψε κάποιο σφάλμα!',
			'An error occurred!': 'Προέκυψε κάποιο σφάλμα!',
			'No data found!': 'Δεν βρέθηκαν δεδομένα!',
		},
		en: {
			'More': 'More..',
		}
	},
	[Namespaces.UNDER_CONSTRUCTION]: {
		el: {
			'Under Construction': 'Σύντομα Κοντά Σας',
			'Please check out your catalogue later. We are doing some maintenance on it right now.': 'Η σελίδα καταλόγου είναι υπο κατασκευή και θα είναι σύντομα διαθέσιμη.',
			'Back To Home': 'Επιστροφή Στην Αρχική'
		},
		en: {}
	},
}

export default locales
